import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Box,
  Typography,
  IconButton,
  Divider,
  LinearProgress,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useDarkMode } from "../../hooks/useDarkMode";
import base from "../../apis";

export const headers = [
  {
    name: "",
    subs: [
      {
        content: (
          <>
            Welcome and thank you for your curiosity in BPO Homes and (BPO Homes
            Inc. also, its associated marks or potentially benefits recorded in
            Section 2, altogether, the BPO Homes Company," "us," "our," or "we"
            ). By clicking an enrollment or new record accommodation button, or
            by in any case utilizing our sites, organizations, versatile
            applications, or different administrations given by the BPO Homes
            Company (altogether, the "Administrations") you consent to be
            limited by the accompanying terms of purpose, as refreshed every now
            and then (the "Terms of Use").
            <br /> <br /> 1. The BPO Homes Company Role.
            <br />
            The BPO Homes Company, and the Services given by BPO Homes, may help
            you in playing out the different undertakings in a land, property,
            or home exchange. In any case, except if unequivocally indicated by
            the terms of purpose for a specific Service (each a "Item's Terms"),
            THE SERVICES ARE NOT INTENDED TO furnish you with any monetary,
            land, property, or financial related guidance of any sort. You fully
            understand and concur that the Services might incorporate
            promotions. To assist with making the commercials applicable and
            helpful to you, the BPO Homes Companies might serve ads in light of
            the data we gather through the Services. See the Privacy Policy for
            additional subtleties. A. BPO Homes, Inc. may have a land specialist
            permit in specific states (see Section 21). Nonetheless, except if
            accommodated in your Product's Terms, BPO Homes Inc takes care of
            any outcome or result related straightforwardly or by implication to
            any activity or inaction that you or any buyer takes in view of the
            Services or some other data accessible through or regarding the
            Services.
            <br /> <br /> 2. BPO Realty Subscription
            <br />
            Agents, Realtors & Brokers and or Broker Associates who subscribe to
            BPO Realty or BPO Tech agree to join BPO Realty or BPO Tech for a
            minimum one year period beginning from the initial date of sign up
            with BPO Homes. Upon any Termination by BPO Realty or BPO Tech
            subscription, the Cancelation by Agent or Transfer of Agent or
            Broker Real Estate License to any other Brokerage prior to the end
            of the initial one year period, BPO Realty Agents or BPO Tech
            subscribers are to be charged the entire remaining balance of that
            one year period based on the total remaining Monthly Payments for
            that period
            <br /> <br /> 3. The BPO Homes Company Brands and Business models.
            <br />
            We work with the accompanying partnered brands and administrations,
            any utilization of any of the Services given by the accompanying
            subsidiary brands is dependent upon these Terms of Use: (a) ; (b)
            BPO Homes Farm Agent (c) BPO Homes Deal Analyzer; (d) BPO Homes
            Premier Agent (e) BPO Homes Active Listing Report Agent; Services
            offered might be dependent upon a Product's Terms or extra terms of
            purpose as accessible on their separate sites, organizations,
            versatile applications or in any case. A. Partnered Business
            Relationship Notice: This is to give you notice of business
            connections among the accompanying suppliers. BPO Homes Inc. ("BPO
            HOMES,") which works with and is a part of BPOHomes.com and by
            implication entirely possessed by BPO Homes Inc. through at least
            one auxiliaries. On account of these connections, any references in
            regards to BPO Homes Inc organization might give the alluded
            organization, its immediate or circuitous parent (BPO Homes)
            (BPOHomes.com), and their particular representatives a monetary or
            other advantage.
            <br /> <br /> 4. Qualification; Accounts and Registration
            <br />
            You must be at least 18 years old to utilize the Services. By
            consenting to these Terms of Use, you address and warrant that: (a)
            you are at least 18 years old; (b) you have not recently been
            suspended or taken out from the Services; and (c) your enlistment
            and your utilization of the Services is in consistence with every
            material regulation and guidelines. To get to certain highlights of
            the Services, you might be expected to enlist for consent to a
            Product's Terms, to the degree relevant to that help, which might be
            fused thus or accessible on a different BPO Homes Company site.
            Whenever you register for a record you will be approached to give us
            some data about yourself, for example, email address, telephone
            number, or other contact data. You concur that the data you give is
            exact and that you will stay up with the latest consistently.
            Whenever you register, you may be approached to give a secret phrase
            or answer a secret question. You are exclusively liable for keeping
            up with the secrecy of secret words or answers, and you are liable
            for all activities considered. You may not share your client
            account(s) with others. Except if you have gone into a business
            concurrence with us allowing you to involve the Services for
            exchanges for the benefit of someone else, you may just involve the
            Services for exchanges for your own sake.
            <br />
            5. Utilization of the Services; Restrictions. A. Utilization of the
            Services. However long you follow these Terms of Use, we award you a
            non-elite, restricted, revocable, individual, non-adaptable permit
            to utilize the Services, and to download and utilize any App (as
            characterized in Section 4(B) underneath) on your cell phone in
            object code structure, for your own utilization. In the event that
            you are a land or home loan proficient acting in your expert limit,
            you may furthermore utilize the Services to give data, to the degree
            allowed by relevant regulation, to your clients and to make moves
            for the benefit of your clients ("Pro Use"). Assuming you utilize
            the Services for a Pro Use, you address and warrant that you have
            gotten every single required approval and assents from your client.
            Besides as explicitly expressed in this, these Terms of Use don't
            give you a permit to utilize, imitate, disseminate, show or give
            admittance to any piece of the Services on outsider sites or in any
            case. The Services might remember programming for use for
            association with the Services. The Services may not be utilized for
            exchanges in business land, which incorporates, without limit,
            industrially drafted properties and excursion rentals. B. Versatile
            Applications. To utilize any versatile application element of the
            Services (each, an "Application"), you should have a viable cell
            phone. We don't warrant that any App will be viable with your cell
            phone. You might involve portable information regarding an App and
            may cause extra charges from your remote supplier for utilizing an
            App. You concur that you are exclusively liable for any appropriate
            charges. We might refresh any application and may consequently
            electronically refresh the adaptation of any App that you have
            introduced on a cell phone. You agree to every single programmed
            redesign, and comprehend that these Terms of Use will apply to all
            refreshed forms of an App. Any outsider open source programming
            remembered for an App is dependent upon the pertinent open source
            permit and might be accessible straightforwardly from the maker
            under an open source permit. These Terms of Use don't have any
            significant bearing to your utilization of programming obtained from
            an outsider source under an open source permit. C. Utilization of
            Content. Depending upon the limitations set out in these Terms of
            Use, you may NOT duplicate data from the Services with the guide of
            any robotized processes. Just as important for your own utilization
            view, save, print, fax and additionally email such data. Any
            reference may exclude any of our logos without our earlier composed
            endorsement or suggest any connection among you and the BPO Homes
            Company. You are restricted from showing some other BPO Homes
            Company' information without our earlier composed endorsement.
            <br /> <br />
            6. Precluded Use. BY USING THE SERVICES, YOU AGREE NOT TO:
            <br />
            imitate, change, convey, show or in any case give admittance to,
            make subsidiary works from, decompile, dismantle, or pick apart any
            piece of the Services, besides as expressly allowed by any Product's
            Terms to the degree pertinent to that item's Services;
            give/post/approve a connection to any of the Services (counting
            however not restricted to a specialist profile page) from an
            outsider site that is anything but a land related site claimed or
            worked by a land or loaning proficient or establishment; eliminate
            or adjust any copyright or other licensed innovation that showing in
            the Services; utilize the Services in any capacity that is unlawful,
            or hurts BPO Homes Inc, its specialist organizations, providers,or
            some other client; utilize the Services in any capacity to victimize
            any individual or class of people safeguarded under government,
            state or nearby regulations, or which might have an unfair effect
            against any individual or class of people, or which in any case
            advances unlawful, bigot or prejudicial exercises or results; convey
            or post spam or send other spontaneous messages, networking letters,
            fraudulent business models through the Services; mimic someone else,
            distort your alliance with someone else or element, or make any
            portrayal to any outsider deceptively; duplicate, openly show, or in
            any case make open on or through some other site, application, or
            administration any surveys, appraisals, or profile data about land,
            loaning, or different experts, basic pictures of or data about land
            postings, or different information or content accessible through the
            Services, besides as expressly allowed by us for a specific part of
            the Services; transfer invalid information, infections, worms, or
            other programming specialists to the Services; post, imitate, freely
            show, and prudence act hostile or offensive to including without
            limit content that bugs, separates, belittles, compromises or
            demonizes any individual or class of people; slow down, or
            compromise the framework uprightness or security of the Services, or
            in any case sidestep any actions we might use to forestall or limit
            admittance to the Services; lead robotized inquiries (counting
            screen and data set scratching, insects, robots, crawlers, bypassing
            "manual human test" or comparable precautionary measures, or some
            other computerized action determined to get data from the Services)
            on the Services; utilize any of the BPO Homes brand names as a
            feature of your screen name or email address on the Services; access
            or utilize any of the Services to foster serious items or
            administrations; or endeavor to, or allow or urge any outsider to,
            do any of the above mentioned.
            <br /> <br /> 7. Charges.
            <br />
            A. For the most part. You might be expected to pay charges to get to
            specific highlights of the Services. All charges are in U.S. dollars
            and are non-refundable. Assuming that we change the expenses for all
            or part of any of the Services, including by adding expenses or
            charges, we will give you advance notice of those changes. On the
            off chance that you don't acknowledge the changes, we might suspend
            giving the relevant piece of the Services to you. Our approved
            outsider installment processors will charge the installment strategy
            you indicated at the hour of procurement or as consented to as a
            feature of the chosen Service. You approve us to charge all expenses
            as depicted in these Terms of Use for the Services you select to
            that installment technique. Assuming you pay any charges with a
            Mastercard, we might look for pre-approval of your Mastercard
            account before your buy to check that the Mastercard is substantial
            and has the essential assets or credit accessible to cover your buy.
            B. Memberships. The Services might incorporate elements that
            consider naturally repeating installments for occasional charges
            ("Subscription Service"). Assuming that you choose to initiate a
            Subscription Service, you approve us to intermittently charge, on an
            ongoing-ahead premise and until scratch-off of either the repetitive
            installments or your record, all accumulated totals at the very
            latest the installment due date for the gathered aggregates. The
            membership will proceed except if and until you drop your
            membership, or we end it. You should drop your Subscription Service
            before it restores to try not to bill the following occasional
            membership expense to your record. We will charge the intermittent
            membership expense to the installment strategy you give to us during
            enrollment (or to an alternate installment technique assuming that
            you change your installment data). We might change the membership
            charge for any resulting membership period yet will give you early
            notification of any increment before it applies. Except if not
            expressed in your Product's Terms, you might drop a Subscription
            Service through the settings page in your record; by reaching us at,
            consumercare@bpohomes.com; or on the other hand, if appropriate, by
            reaching your business advisor.
            <br /> <br />
            8. Client Materials.
            <br />
            A. UGC Definition; License Grant. Certain segments of the Services
            might permit clients to transfer or in any case give the BPO Homes
            pictures, photographs, video, information, text, postings, and other
            substance ("User Materials"). Missing any extra terms given in your
            Product's Terms, by transferring or in any case giving User
            Materials to the Services, you award us an unalterable, unending,
            sovereignty free overall permit to: (I) use, duplicate, circulate,
            communicate, openly show, openly perform, imitate, alter, adjust,
            plan subordinate works of or consolidate into different works, and
            interpret your User Materials, regarding the Services or in some
            other media; and (ii) sublicense these privileges, to the greatest
            degree allowed by relevant regulation. We won't pay you for your
            User Materials or to practice any privileges connected with your
            User Materials set out in the first sentence. We might eliminate or
            alter your User Materials whenever. You are exclusively answerable
            for all User Materials made through your client account(s) on the
            Services or that you in any case make accessible through the
            Services. For all User Materials, you address and warrant that you
            are the maker and proprietor of the User Materials, or have the
            important licenses, freedoms, assents, and authorizations (counting
            all consents expected under relevant security and protected
            innovation regulation) to approve the BPO Homes organization and
            different clients to access and involve your User Materials as
            important to practice the licenses conceded by you under these Terms
            of Use. We won't utilize client contact data that is transferred by
            specialists into the BPO Farm Agent Hub/Portal or Agent entryway for
            any reason, except if that client contact data is generally given to
            us straight by the client. B. Disclaimer. We are under no commitment
            to alter or control your User Materials or the User Materials of
            some other User and won't be in any capacity capable or obligated
            for any User Materials. We may, in any case, whenever and without
            earlier notification, screen, eliminate, alter, or block any User
            content on the Services, including User Materials, which in our only
            judgment abuses these Terms of Use or we see as in any case
            offensive, including any infringement of our Happy Customer Policy,
            portrayed in Section 13(B). You comprehend that while utilizing the
            Services, you might be presented to User Materials of different
            clients and recognize that User Materials might be incorrect,
            hostile, profane, or shocking. You consent to postpone, and do
            forgo, any legitimate or impartial right or cure you might have
            against us concerning User Materials. We explicitly renounce all
            responsibility regarding User Materials. Whenever told by a client
            or content proprietor that User Materials purportedly don't adjust
            with these Terms of Use, we might examine the claim and decide in
            our only attentiveness whether to eliminate those User Materials,
            which we maintain all authority to do whenever and without notice.
            For more data on our treatment of encroaching substance, kindly see
            Section 11 underneath.
            <br /> <br />
            9. Outsider/Linked Services/Sent data.
            <br />
            A. For the most part. The Services incorporate connections to
            outsider items, administrations, and sites, as well as materials
            given by outsiders, and may incorporate usefulness that considers
            the circulation of your User Materials or your own data (all in all,
            your "Client Information") to outsiders not under the our influence
            (each, a "Outsider Provider"). Outsider Providers are exclusively
            liable for their administrations. You are answerable for your
            utilization and accommodation of User Information to any outsider,
            and your dealings or business directed with any outsider emerging
            regarding the Services are exclusively among you and such outsider.
            Your utilization of outsider locales, administrations, or items
            might be liable to related outsider terms of purpose and protection
            approaches or different arrangements, which you are exclusively
            answerable for following. We don't embrace, and assume a sense of
            ownership with such items, administrations, Web destinations, and
            materials, or a Third-Party Provider's utilization of your User
            Information. By utilizing an instrument that takes into
            consideration User Information to be moved, you concur that we might
            move the material User Information or other data to the pertinent
            outsiders, which are not influenced quite a bit by. Assuming you
            present a contact structure or in any case show your advantage in
            reaching a Third-Party Provider, you might get selling calls from
            the Third-Party Provider utilizing the contact data you gave.
            Outsider Providers might keep your contact data and some other data
            got by the Third-Party Provider in handling a contact or other
            solicitation structure. We are not liable for any harming of any
            party or expenses of any kind emerging out of or in any capacity
            associated with your dealings with these outsiders. B. Certain
            Third-Party Services. (i) Referrals and Lead Sales. As a feature of
            the Services, you might be associated with a realtor. You approve us
            to make such reference or lead and recognize that we might be paid
            significantly for working with such an association. As a component
            of the Services, you might be associated with a party that gives
            contract credit beginning administrations, title and escrow
            administrations, or other settlement administrations. . If any of
            these gatherings have a subsidiary relationship with BPO Homes Inc,
            then, at that point, BPO Homes Inc might get a monetary or other
            advantage from the reference between such partners C. Extra Terms
            for Third Party Services. Certain parts of the Services incorporate
            outsider devices that are dependent upon extra outsider terms,
            including, however not restricted to, the accompanying: (i) Stripe.
            A portion of the Services permit you to utilize Stripe Connect to
            make installments to different clients and may incorporate extra
            handling or application expenses point by point when you decide to
            associate with Stripe. Your utilization of Stripe is dependent upon
            the Stripe Connected Account Agreement, accessible at
            https://stripe.com/us/associate record/lawful. Moreover, by
            utilizing Stripe, you make a deal to avoid utilizing Stripe (and the
            Services for the most part) for any Prohibited Business purposes, as
            recorded at https://stripe.com/us/disallowed organizations.
            <br /> <br />
            10. Licensed Innovation.
            <br />
            The Services are possessed and worked on by BPO Homes Inc. The UIs,
            plan, data, information, code, items, programming, illustrations,
            and any remaining components of the Services ("BPO Homes Inc
            Materials") that we give are safeguarded by protected innovation and
            different regulations and are the property of the BPO Homes Inc or
            the BPO Homes Inc outsider licensors. Besides as explicitly
            permitted by these Terms of Use, you may not utilize the BPO Homes
            Inc ' Materials, and the BPO Homes Inc Companies general privileges
            that are not allowed explicitly in these Terms of Use. Licensed
            innovation Notices: Certain substances on the Services are possessed
            by ZIP+4 information and the United States Postal Service. To see a
            total rundown of our given licenses and dynamic brand names, visit
            bpohomes.com/Trademarks/Patents. The names of real organizations,
            items, and administrations referenced in this might be the brand
            names of their separate proprietors. Any freedoms not explicitly
            conceded thus are saved. We don't declare copyright or award any
            freedoms to the basic pictures or portrayals of land postings
            offered through the Types of assistance. Any utilization of these
            pictures and depictions is dependent upon the copyright proprietor's
            authorization and the necessities of appropriate regulation.
            <br /> <br />
            11. Feedback.
            <br />
            Assuming you decide to give info and ideas in regards to the
            Services, including connection with any of The Company' Materials
            ("Feedback"), then, at that point, you thus award us an unlimited,
            unending, unalterable, non-selective, completely paid, sovereignty
            free right to involve the Feedback in any way and for any reason,
            including the work on the services.
            <br /> <br />
            12. Claims of Copyright Infringement.
            <br />
            We regard the licensed innovation privileges of others and ask that
            everybody utilizing the Services do likewise. Any individual who
            accepts that their work has been replicated on the Services in a
            manner that establishes copyright encroachment might tell our
            copyright specialist as per Title 17, United States Code, Section
            512(c)(2), by giving the accompanying data: (i) Recognizable proof
            of the protected work that you guarantee has been encroached; (ii)
            Recognizable proof of the material that you guarantee is encroaching
            and should be eliminated, including a depiction of where it is
            situated on the Services so the copyright specialist can find it;
            (iii) Your location, phone number, and, if accessible, email
            address, so the copyright specialist might get in touch with you
            about your objection; and (iv) A marked explanation that the above
            data is exact; that you have a decent confidence conviction that the
            distinguished utilization of the material isn't approved by the
            copyright proprietor, its representative, or the law; and, under
            punishment of prevarication, that you are the copyright proprietor
            or are approved to follow up for the copyright proprietor's sake
            experiencing the same thing. Notification of copyright encroachment
            cases ought to be sent as follows: Via mail: BPO Tech Inc 6920 Santa
            Teresa Blvd. Suite 208 San Jose, CA 95119 Consideration: Copyright
            Agent By e-mail:operations@bpohomes On the off chance that you pull
            out of copyright encroachment by email, we might start examining the
            supposed copyright encroachment; nonetheless, we should accept your
            marked assertion via mail or as a connection to your email before we
            are expected to make any move.
            <br /> <br />
            13. Deactivation/Deletion/Changes to Agreement.
            <br />
            Besides as expressed in any Product's Terms, you might deactivate
            your record out of the blue by choosing "deactivate account" in your
            record settings. You can erase your record and all of your record
            information by presenting a solicitation to "erase your information"
            at. In the event that you deactivate or erase your record, you stay
            committed to pay generally exceptional expenses, if any, causing
            preceding end connecting with your utilization of the Services. In
            the event that you disregard any arrangement of these Terms of Use,
            your consent from the BPO Homes Inc to utilize the Services will end
            naturally. Likewise, we may, in our only caution, deactivate,
            suspend, or end your admittance to your record and the Services
            whenever under any condition, regardless of notice. We might adjust,
            suspend or end the Services or any part of the Services without
            notice. We won't be responsible at all for any change to the
            Services or any suspension or end of your admittance to, or
            utilization of the Services. We maintain all authority to change
            these Terms of Use whenever in its carefulness on a going-ahead
            premise. We will put forth industrially sensible attempts to tell
            you of any material changes to these Terms of Use. Your proceeding
            with utilization of the Services after any updates are successful
            will address your consent to the changed form of the Terms of Use.
            Your proceeding with utilization of the Services after the viability
            of such changes will establish acknowledgment of, and consent to,
            any such changes. You further postpone any right you might need to
            get explicit notification of such changes to these Terms of Use. You
            are liable for routinely auditing these Terms of Use. 14. Protection
            Policy/Other Terms. A. Protection Policy. BPO Homes Inc will gather,
            use, store, and uncover individual data as per our Privacy Policy.
            If it's not too much trouble, counsel the Privacy Policy for more
            data, which is consolidated into, and made a part of, these Terms of
            Use. B. BPO Homes Premier Agent disclaimer terms are consolidated
            into, and made a part of these Terms of Use. C. BPO Homes Farm Agent
            disclaimer terms are consolidated into, and made a part of these
            Terms of Use. D. BPO Homes Deal Analyzer disclaimer terms are
            consolidated into, and made a part of these Terms of Use. E. BPO
            Homes Active Listing Agent disclaimer terms are consolidated into,
            and made a part of these Terms of Use. F. BPO Homes Report
            disclaimer terms are consolidated into, and made a part of this
            Terms of Use. G. BPO Homes Deal Analyzer & Proforma disclaimer terms
            are consolidated into, and made a part of this Terms of Use. H.
            Different Terms. Your utilization of the Services is dependent upon
            every one of extra rules, runs, Product's Terms, and arrangements
            pertinent to the Services or certain highlights of the Services that
            we might post on, or connection to, from the Services, for example,
            rules appropriate to a specific item or content accessible through
            the Services, including, without restriction, the Friendly Neighbor
            Policy, the Listing Quality Policy, the BPO Farm Agent disclaimer,
            the BPO Premier Agent Disclaimer, The BPO Active Listing Disclaimer,
            the BPO Deal Analyzer Disclaimer and the Video Guidelines strategy.
            Furthermore, assuming that you are a non-associated Third-Party
            Provider who partakes in any Services presented by BPO Homes Inc.
            All such terms are joined into, and made a piece of, these Terms of
            Use.
            <br /> <br />
            15. Reimbursement.
            <br />
            You consent to reimburse, guard, and hold innocuous the BPO Homes
            Inc, their subsidiaries, and their particular chiefs, officials,
            workers, and specialists from all possible cases and requests made
            by any outsider due to or emerging out of: (a) your admittance to or
            utilization of the Services; (b) your break of these Terms of Use;
            (c) your infringement of any regulation or the privileges of an
            outsider; (d) any debate or issue among you and any outsider; (e)
            any User Materials you transfer to, or in any case make accessible
            through, the Services; (f) your resolute unfortunate behavior; and
            (g) some other party's admittance to or utilization of the Services
            utilizing your record and secret key. BPO Homes Inc hold the right,
            at their own cost, to accept the select guard and control of any
            matter in any case dependent upon reimbursement by you, and all
            things considered, you consent to cooperate with the BPO Homes Inc
            protection of that case.
            <br />
            <br />
            16. No Warranties.
            <br />
            BPO Homes Inc PROVIDE THE SERVICES "With no guarantees," "WITH ALL
            FAULTS" AND "AS AVAILABLE," AND THE ENTIRE RISK AS TO SATISFACTORY
            QUALITY, PERFORMANCE, ACCURACY, AND EFFORT IS WITH YOU. TO THE
            MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE BPO HOMES INC AND
            ITS SUPPLIERS MAKE NO REPRESENTATIONS, WARRANTIES OR CONDITIONS,
            EXPRESS OR IMPLIED. BPO HOMES INC AND THEIR SUPPLIERS EXPRESSLY
            DISCLAIM ANY AND ALL WARRANTIES OR CONDITIONS, EXPRESS, STATUTORY
            AND IMPLIED, INCLUDING WITHOUT LIMITATION: (A) WARRANTIES OR
            CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
            WORKMANLIKE EFFORT, ACCURACY, TITLE, QUIET ENJOYMENT, NO
            ENCUMBRANCES, NO LIENS AND NON-INFRINGEMENT; (B) WARRANTIES OR
            CONDITIONS ARISING THROUGH COURSE OF DEALING OR USAGE OF TRADE; AND
            (C) WARRANTIES OR CONDITIONS OF UNINTERRUPTED OR ERROR-FREE ACCESS
            OR USE. NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED
            BY YOU THROUGH THE SERVICES OR ANY MATERIALS AVAILABLE THROUGH THE
            SERVICES WILL CREATE ANY WARRANTY REGARDING ANY BPO HOMES INC ENTITY
            OR THE SERVICES THAT ARE NOT EXPRESSLY STATED IN THESE TERMS OF USE.
            YOU ASSUME ALL RISK FOR ANY DAMAGE THAT MAY RESULT FROM YOUR USE OF
            OR ACCESS TO THE SERVICES, YOUR DEALING WITH ANY OTHER USER, AND ANY
            MATERIALS, INCLUDING ALL USER AND BPO HOMES MATERIALS, AVAILABLE
            THROUGH THE SERVICES. YOU UNDERSTAND AND AGREE THAT YOUR USE OF THE
            SERVICES, AND USE, ACCESS, DOWNLOAD, OR OTHERWISE OBTAINMENT OF
            MATERIALS THROUGH THE SERVICES AND ANY ASSOCIATED SITES OR SERVICES,
            ARE AT YOUR OWN DISCRETION AND RISK, AND THAT YOU ARE SOLELY
            RESPONSIBLE FOR ANY DAMAGE TO YOUR PROPERTY (INCLUDING YOUR COMPUTER
            SYSTEM OR MOBILE DEVICE USED IN CONNECTION WITH THE SERVICES), OR
            THE LOSS OF DATA THAT RESULTS FROM THE USE OF THE SERVICES OR THE
            DOWNLOAD OR USE OF THOSE MATERIALS. A FEW JURISDICTIONS MAY PROHIBIT
            A DISCLAIMER OR WARRANTIES AND YOU MAY HAVE OTHER RIGHTS THAT VARY
            FROM JURISDICTION TO JURISDICTION.
            <br /> <br />
            17. Impediment of Liability/Exclusive Remedy.
            <br />
            IN NO EVENT WILL BPO HOMES INC OR ANY OF THEIR AFFILIATES BE LIABLE
            FOR ANY INDIRECT, CONSEQUENTIAL, SPECIAL, INCIDENTAL, OR PUNITIVE
            DAMAGES (INCLUDING DAMAGES FOR LOSS OF PROFITS, GOODWILL, OR ANY
            OTHER INTANGIBLE LOSS) ARISING OUT OF, BASED ON, OR RESULTING FROM
            THESE TERMS OF USE OR YOUR USE OR ACCESS, OR INABILITY TO USE OR
            ACCESS, THE SERVICES OR ANY MATERIALS ON THE SERVICES, WHETHER BASED
            ON: (A) BREACH OF CONTRACT; (B) BREACH OF WARRANTY; (C) NEGLIGENCE;
            OR (D) ANY OTHER CAUSE OF ACTION, EVEN IF BPO HOMES HAS BEEN ADVISED
            OF THE POSSIBILITY OF SUCH DAMAGES. TO THE MAXIMUM EXTENT PERMITTED
            BY APPLICABLE LAW, THE BPO HOMES LIABILITY OR RESPONSIBILITY FOR ANY
            (I) ERRORS, MISTAKES, OR INACCURACIES OF MATERIALS; (II) PERSONAL
            INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM
            YOUR ACCESS TO OR USE OF THE SERVICES; (III) ANY UNAUTHORIZED ACCESS
            TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL
            INFORMATION STORED THEREIN; (IV) ANY INTERRUPTION OR CESSATION OF
            TRANSMISSION TO OR FROM THE SERVICES; (V) ANY BUGS, VIRUSES, TROJAN
            HORSES, OR THE LIKE THAT MAY BE TRANSMITTED TO OR THROUGH OUR
            SERVICES BY ANY THIRD PARTY; (VI) ANY ERRORS OR OMISSIONS IN ANY
            MATERIALS OR FOR ANY LOSS OR DAMAGE INCURRED AS A RESULT OF THE USE
            OF ANY MATERIALS POSTED, EMAILED, TRANSMITTED, OR OTHERWISE MADE
            AVAILABLE THROUGH THE SERVICES; OR (VII) USER MATERIALS OR THE
            DEFAMATORY, OFFENSIVE, OR ILLEGAL CONDUCT OF ANY THIRD PARTY. THE
            AGGREGATE LIABILITY OF BPO Homes Company AND ANY OF THEIR AFFILIATES
            TO YOU FOR ALL CLAIMS ARISING OUT OF OR RELATING TO THE USE OF, OR
            INABILITY TO USE, ANY PORTION OF THE SERVICES OR OTHERWISE UNDER
            THESE TERMS OF USE, WHETHER UNDER CONTRACT, TORT, OR OTHERWISE, IS
            LIMITED TO THE GREATER OF: (1) THE AMOUNT YOU HAVE PAID TO THE BPO
            Homes Company FOR THE SERVICES IN THE 12 MONTHS PRIOR TO THE EVENTS
            OR CIRCUMSTANCES GIVING RISE TO THE CLAIMS; OR (2) $100. A FEW
            JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY
            FOR CONSEQUENTIAL DAMAGES. AS NEEDS BE, THE ABOVE LIMITATIONS MAY
            NOT APPLY TO YOU. EACH PROVISION OF THESE TERMS OF USE THAT PROVIDES
            FOR A LIMITATION OF LIABILITY, DISCLAIMER OF WARRANTIES, OR
            EXCLUSION OF DAMAGES IS INTENDED TO AND DOES ALLOCATE THE RISKS
            BETWEEN THE PARTIES UNDER THESE TERMS. THIS ALLOCATION IS AN
            ESSENTIAL ELEMENT OF THE AGREEMENT OF THE PARTIES. THE LIMITATIONS
            IN THIS SECTION WILL APPLY EVEN IF ANY LIMITED REMEDY FAILS ITS
            ESSENTIAL PURPOSE.
            <br /> <br />
            18. Decision of Law; Resolution of Disputes.
            <br />
            These Terms of Use are administered by the laws of the State of
            California, without giving impact to its contention of regulations'
            arrangements. You consent to submit to the individual and elite
            locale and scene in the state and government courts sitting in Santa
            Clara County, California for all possible debates, claims and
            activities emerging from or regarding the Services or in any case
            under these Terms of Use. BPO Homes work the Services from its
            workplaces in California, and we make no portrayal that the Services
            are suitable or accessible for use in different areas.
            <br /> <br /> 19. General.
            <br />
            You make a deal to avoid trading from anyplace any piece of the
            Services given to you, or any immediate item thereof, besides in
            accordance with, and with all licenses and endorsements expected
            under, appropriate commodity regulations, rules and guidelines. All
            Services utilized by the U.S. Government are furnished with the
            business permit privileges depicted thus. These Terms of Use may
            just be revised by a composed understanding endorsed by approved
            agents of the gatherings to these Terms of Use. Assuming any piece
            of these Terms of not entirely set in stone to be invalid or
            unenforceable, then the invalid or unenforceable arrangement will be
            supplanted with a legitimate, enforceable arrangement that most
            intently matches the goal of the first arrangement and the rest of
            these Terms of Use will go on active. The segment titles in these
            Terms of Use are exclusively utilized for the accommodation of the
            gatherings and have no lawful or legally binding importance. We
            might appoint this Agreement, in entire or to some degree, whenever
            regardless of notice to you. You may not appoint these Terms of Use,
            or allocate, move or sublicense your privileges, if any, in the
            Services. Our inability to act as for a break, or our decision to in
            any case defer break, by you or others doesn't forgo its on the
            right track to act as for resulting or comparative breaks. Besides
            as explicitly expressed thus, these Terms of Use, and all explicitly
            fused terms and arrangements, establish the whole understanding
            among you and the BPO Homes Inc as for the Services and all earlier
            or contemporaneous interchanges of any sort among you and BPO Homes
            as for the Services. The accompanying segments of these Terms of Use
            will endure any end of these Terms of Use: 3, 5-8, 10-12, and 14-21.
            <br /> <br /> 20. Agree to Communications.
            <br />
            By utilizing the Services, you agree to getting specific electronic
            interchanges from us as additionally portrayed in the Privacy
            Policy. If it's not too much trouble, read the Privacy Policy to
            find out additional information. You concur that any notification,
            arrangements, divulgences, overviews, or different correspondences
            that we ship off you electronically will fulfill any legitimate
            correspondence necessities, including that those interchanges be
            recorded as a hard copy. The Services might give web structures,
            connections, or contact data, including telephone numbers, that can
            interface you with the BPO Homes or outsiders, like realtors and
            Third-Party Providers. Interchanges through these techniques might
            be steered through an outsider help ("Communications Service").
            Calls might be recorded or observed for quality confirmation,
            preparing, or client support purposes. You will be informed toward
            the start of a call assuming that it very well might be recorded or
            observed. You agree to such recording and observing by the BPO Homes
            Company or the Communications Service. We likewise utilize the
            Communications Service to follow calls and instant messages among
            you and realtors so we and the realtor can get specific insights
            regarding the contact. As a component of this cycle, we and the
            Communications Service will progressively store information about
            your call or instant message, including the date and season of the
            call or instant message, your telephone number, and the substance of
            the instant message. You agree to these practices by us and the
            Communications Service. The data is dependent upon the Privacy
            Policy. As to Service or to get additional data in regards to
            utilization of the Service.
            <br /> <br />
            21. Messaging Terms & Conditions
            <br />
            A. When you opt-in to the service, we will send you a message to
            confirm your signup. By opting into messages, you agree to receive
            recurring automated marketing and informational text messages from
            BPO Homes for Belinda. Automated messages may be sent using an
            automatic telephone dialing system to the mobile telephone number
            you provided when signing up or any other number that you designate.
            Message frequency varies, and additional mobile messages may be sent
            periodically based on your interaction with Belinda. BPO Homes
            reserves the right to alter the frequency of messages sent at any
            time to increase or decrease the total number of sent messages. BPO
            Homes also reserves the right to change the short code or phone
            number where messages are sent. Message and data rates may apply. If
            you have any questions about your text plan or data plan, it is best
            to contact your wireless provider. Your wireless provider is not
            liable for delayed or undelivered messages. Your consent to receive
            marketing messages is not a condition of purchase. B. Carriers are
            not liable for delayed or undelivered messages. C. You can cancel
            any time by texting "STOP". After you send the SMS message "STOP",
            we will send you a message to confirm that you have been
            unsubscribed and no more messages will be sent. If you would like to
            receive messages from BPO Homes again, just sign up as you did the
            first time and BPO Homes will start sending messages to you again.
            D. Text "HELP" at any time and we will respond with instructions on
            how to unsubscribe. For support regarding our services, email us at
            support@bpohomes.com. E. You agree that before changing your mobile
            number or transferring your mobile number to another individual, you
            will either reply “STOP” from the original number or notify us of
            your old number at support@bpohomes.com. The duty to inform us based
            on the above events is a condition of using this service to receive
            messages. F. If you have any questions about your data or our
            privacy practices, please visit our [Privacy Policy] G. We reserve
            the right to change or terminate our messaging program at any time.
            We also reserve the right to update these Messaging Terms at any
            time. Such changes will be effective immediately upon posting. Your
            continued enrollment following such changes shall constitute your
            acceptance of such changes
            <br /> <br />
            22. Contact Information and License Disclosures.
            <br />
            The Services are presented by BPO Homes Inc and its partners,
            located 6920 Santa Teresa Blvd. Suite 208 San Jose CA 95119. You
            might contact the BPO Homes Inc by sending correspondence to that
            location or messaging consumercare@bpohomescom. BPO Homes is an
            entirely claimed auxiliary of BPO Homes Inc. also, has its base camp
            at 6920 Santa Teresa Blvd. Suite 208 San Jose CA 95119
            <br /> <br />
            23. Notice to Apple Users.
            <br />
            Assuming you are utilizing our portable applications on an iOS
            gadget, the particulars of this Section 21 apply. You recognize that
            these Terms of Use are among you and the BPO Homes Inc just, not
            with Apple, and Apple isn't answerable for the Services or related
            Materials. Apple has no commitment to outfit any upkeep or backing
            administrations as for the Services. Assuming that the Services
            neglect to adjust to any pertinent guarantee, you might advise Apple
            and Apple will discount any appropriate price tag for the versatile
            application to you; and, to the greatest degree allowed by material
            regulation, Apple has no other guarantee commitment concerning the
            Services. Apple isn't answerable for tending to any case by you or
            any outsider connecting with the Services or your ownership or
            utilization of the Services, including: (a) item responsibility
            claims; (b) any case that the Services neglect to adjust to any
            pertinent lawful or administrative prerequisite; and (c) claims
            emerging under buyer insurance or comparable regulation. Apple isn't
            answerable for the examination, safeguard, settlement or release of
            any outsider case that the Services or your ownership and
            utilization of the versatile application encroach that outsider's
            protected innovation freedoms. You consent to conform to any
            pertinent outsider terms while utilizing the Services. Apple and
            Apple's auxiliaries are outsider recipients of Section 21 of these
            Terms of Use, and upon your acknowledgment of these Terms or Use,
            Apple will have the right (and will be considered to have
            acknowledged the option) to uphold this Section 21 of these Terms of
            Use against you. You therefore address and warrant that: (I) you are
            not situated in a country that is dependent upon a U.S. Government
            ban, or that is on Title 15, Part 740 Supplement 1, Country Group E
            of the U.S. Code of Federal Regulations; and (ii) you are not
            recorded on any U.S. Government rundown of precluded or limited
            parties.
            <br /> <br />
            24. BPO Homes Posted Listings
            <br />
            Some Listing information posted on BPOHomes.com has been provided by
            public data purchased by BPO Homes Inc or provided directly by
            Listing Brokers, Realtors, and Agents & directly uploaded to the
            BPOHomes.com website. Users and Brokers & Realtors have signed
            disclaimers as BPO Homes Active Listing Agents, BPO Homes Premier
            Agents and BPO Homes Farm Agents. By signing these disclaimers BPO
            Homes Broker & Realtor subscribers have fully authorized BPO Homes
            Inc to post their public listing info and made claim to BPO Homes
            Inc that they have sole rights to the Listing info uploaded to BPO
            Homes Inc, and any other Listing info uploaded to public 3rd party
            sites. Brokers & Realtor subscribers have made the claim that all
            photos, videos, and property descriptions pertaining to such
            listings have been designated by Listing Agent to not be copyright
            protected by any 3rd parties and Brokers & Realtors release any and
            all claims against BPO Homes Inc & BPO Homes.com for any posting of
            such Listing information. All 3rd parties also release all claims
            against BPO Homes Inc & BPO Homes.com for any posting of such
            Listing information granted by Listing Agent.
            <br /> <br />
            25. Photos & Videos, Property Listing Agent Descriptions
            <br />
            All photos, Video, & Listing Agent Property descriptions have been
            authorized by Realtors and or Brokers to post on BPOHomes.com. All
            other Listing data provided by BPOHomes.com has been purchased by
            BPO Homes Inc from 3rd party data companies.
            <br /> <br />
            26. MLS & other Listing Services
            <br />
            BPO Homes Inc may or may not be a partner of your local MLS. If BPO
            Homes is partnered with your local MLS listing then the Listing
            information & data may be provided from the MLS. If BPO Homes is not
            partnered with your local MLS then the Listing data BPOHomes.com may
            not be the same as the MLS data.
            <br /> <br />
            27. Listing & Property Data
            <br />
            Listing Data, BPO Reports Data may or may not be deemed accurate.
            Consumers using BPO Homes.com for such services release all claims
            for any Listing or property data deemed to be inaccurate data.
            <br /> <br />
            28. BPO Reports
            <br />
            BPO reports are intended to assist consumers, Buyers, Sellers, with
            an evaluation of property. A BPO (Broker Price Opinion) is only an
            opinion, nothing more. BPO Homes Inc is a mere facilitator of BPO
            Reports which are provided by Licensed Realtors & or Brokers
            Licensed in the state of where the property is located. Buyers &
            Sellers are not advised to make Home acquisitions or Sell properties
            merely based on BPO Reports. It will always be Buyer or Seller’s
            sole discretion as to whether or not to acquire or sell property.
            <br /> <br />
            29. Deal Analyzer & Proforma Reports
            <br />
            The Deal Analyzer is a web based platform and application. The Deal
            Analyzer is meant to assist the consumers, Realtors & or Brokers to
            input information of the user to the Deal Analyzer platform or app.
            The result for Consumers, Realtors & or Brokers may be different
            from deal to deal or from property to property. Buyer & Sellers are
            not advised to and should not make Home acquisitions or Sell
            properties merely based on Deal Analyzer results and or Proforma
            reports. It will always be Buyer or Seller’s sole discretion as to
            whether or not to acquire or sell property.
            <br /> <br />
            30. Cancellations & Refunds
            <br />
            A. Refunds to Realtors & or Brokers for subscription services must
            be canceled within 48hours or no refund will be issued. B. There are
            no refunds at all for any consumer ordered BPO Reports unless the
            BPO Reporting Agent has not started the Report Process previously to
            refund requests. C. BPO Farm Product: (i) If subscription is made,
            customer has 24hrs to cancel for a full refund. (ii) If subscription
            is made and customers cancel after 24hrs, they pay 50% of the total
            remaining balance for the year.
            <br />
            <br />
            31. Electronic Signatures
            <br />
            Upon electronic signatures acquired by users for policies, services,
            subscriptions and any other applicable documentation signed by the
            user for BPO Homes Inc the documents and all terms of use are fully
            valid and enforceable in this agreement.
            <br /> <br />
            32. Force Majeure
            <br />
            A Party will not be viewed as in default or break of this Agreement,
            and will be pardoned from execution or risk for harms to some other
            party, if and to the degree it will be postponed in or kept from
            performing or completing any of the arrangements of this Agreement,
            emerging out of or from any demonstration, exclusion, or situation
            by or in result of any demonstration of God, pandemic, epidemic,,
            work aggravation, damage, disappointment of providers of materials,
            demonstration of the public foe, war, intrusion, revolt, revolt,
            fire, storm, flood, ice, quake, blast, pestilence, breakage or
            mishap to apparatus or hardware or some other reason or causes past
            such Party's sensible control, including any shortening, request,
            guideline, or limitation forced by legislative, military or
            legitimately settled regular citizen specialists, or by making of
            fixes required by a crisis situation not restricted to those
            recorded above upon the property or gear of the Party or property or
            hardware of others which is considered under the Operational Control
            of the Party. A Force Majeure occasion does exclude a demonstration
            of carelessness or Intentional Wrongdoing by a Party. Any Party
            asserting a Force Majeure occasion will utilize sensible
            perseverance to eliminate the condition that forestalls execution
            and will not be qualified to suspend execution of its commitments in
            any more prominent extension or for any longer term than is expected
            by the Force Majeure occasion. Each Party will utilize its earnest
            attempts to relieve the impacts of such Force Majeure occasion, cure
            its powerlessness to perform, and continue full execution of its
            commitments hereunder.
            <br /> <br />
            33. BPO Homes Farm Agent, BPO Homes Premier Agent, BPO Homes Premier
            Agent Deal Analyzer Combo, & BPO Homes Deal Analyzer
            <br />A one year contract is enforced for the BPO Homes Farm Agent
            BPO Homes Premier Agent, BPO Homes Premier Agent Deal Analyzer
            Combo, & BPO Homes Deal Analyzer subscriptions. The BPO Homes Farm
            Agent, BPO Homes Premier Agent, BPO Homes Deal Analyzer Combo, & BPO
            Homes Deal Analyzer subscriptions can not be canceled after 48 hours
            from the placement of the original order. Upon cancellation prior to
            48 hours no refunds apply. However no further following monthly
            charges to be applied for subscribing Agents who request refund
            within 48 hours after subscribing. Upon cancellation of any of the
            BPO Homes subscriptions after 48 hours of original order placement
            subscriber is to immediately pay the remaining total yearly balance
            owed in full. Upon Agent subscriber cancellation subscriber total
            yearly subscriber balance to be charged and deducted from credit
            card on file. Upon subscriber request for cancellation of
            subscription and BPO Homes Inc's failed attempt to charge the
            original credit or debit card on file due to insufficient funds or
            credit and or debit card denial, subscriber to then provide BPO
            Homes Inc & or BPO Tech with new credit or debit card information to
            pay contractual remaining balance within 24 hours of such credit or
            debit card charge denial. Original Credit or Debit card on file to
            be continually automatically deducted for monthly or yearly payments
            dependent on subscription choice unless subscribing Agent
            unsubscribes and or cancels their subscription. Upon any credit or
            debit card denial for any reason subscriber to update card within 24
            hours or BPO Homes will email, text and or mail bill to subscriber
            for remaining yearly balance Upon BPO Homes inability to charge
            subscriber for 90 days BPO Homes Inc will escalate such collection
            to any 3rd party debt collection company of BPO Homes Inc choice to
            collect the full remaining balance. Any canceled subscriptions
            revert to BPO Partner Agent Subscriptions. Partner Agent
            subscriptions are a Free Service provided by BPO Homes Inc & BPO
            Tech Inc.
            <br />
            <br />
            34. Realty Package Users & Subscribers
            <br />
            All Realty Package Users & Subscribers are subject to a one year
            term and are responsible for a payment of $300.00 USD for the
            purposes of a Yearly Legal Fund & Training Fee. The amount is to be
            deducted from User's preferred payment method on file between
            January 1st and January 31st of each calendar year. Payments may be
            made in advance at request or will be automatically taken out of
            User's first qualifying transaction each calendar year. Exemptions
            allowable: Users with initial subscription dates falling on or after
            October 1st for first calendar year only
          </>
        ),
        render: false,
      },
    ],
  },
];

export const brokerHeaders = [
  {
    name: "Master Broker Referral Agreement",
    subs: [
      {
        content: `BPO Homes,BPO Tech Partner Agent Program.
(a) Subject to the terms and conditions of this
Agreement, BPO Homes, BPO Tech agrees to make available and Broker
agrees to participate in the BPO Homes, BPO Tech Partner Agent Program, 
BPO Homes, BPO Tech national network of real estate brokers and agents.
(b) Broker enters into this Agreement on behalf of itself
and all of its Participating Agents and understands and
accepts that Broker is jointly and severally responsible with
its agents for any Referral Fees payable to BPO Homes, and or BPO Tech.
(c) Broker shall participate in the BPO Homes, and o  BPO Tech Partner Agent Program on a non-exclusive basis for the purpose of assisting
consumers referred by BPO Homes, and or BPO Tech to Broker and/or one of its
agents (each, a “Referral”) with real estate transactions
(“Real Estate Services”), which services may include (i)
placing a Referral’s home on the multiple listing service
and/or other listing databases in which Broker participates
and assisting Referrals in selling property; and (ii) helping
`,
        render: false,
      },
      {
        content: `Referrals find a suitable property to purchase or lease.
(d) By Broker participating in the BPO Homes, and or BPO Tech Partner Agent Program,
BPO Homes, and or BPO Tech agree to make best effort to connect Broker with one
or more Referral(s) to see if Real Estate Services can be
provided.
(e) BPO Homes, and or BPO Tech will own all right, title, and interest (including,
without limitation, all copyrights, trade secrets, patents,
trademarks, and any other intellectual property or
proprietary rights) in and to any Referrals. As the owner of
the Referrals,  BPO Homes, and or BPO Tech retains the right to use the Referrals and
Referral data as it deems fit.
(f) By participating in the BPO Homes, and or BPO Tech Partner Agent Program and
accepting Referrals, Broker agrees: (i) to maintain the
confidentiality of the Referral’s information whether
provided by BPO Homes, and or BPO Tech or the Referral to the extent required by
any law or regulation, including as required by BPO Tech
privacy policy, including the California Consumer Privacy
Act, as applicable; (ii) that  BPO Homes, and or BPO Tech responsibility is solely to
provide Broker with contact and background information
about the Referral and to monitor Broker’s delivery of Real
Estate Services to those Referrals and that BPO Homes, and or  BPO Tech does not
have any responsibility to provide real estate brokerage
services to any Referrals; and (iii) to not interfere with
business relationships of Referrals and any settlement
service providers BPO Homes, and or BPO Tech have introduced such Referral.
(g) As more particularly set forth in the BPO Homes, and or BPO Tech Partner Agents
Terms of Us methods of Referral Contact may be but not limited to the following (phone, email, and or by BPO Homes, and or BPO Tech Platform Tools, etc. ) in which BPO Homes, and or BPO Tech Terms of use established by BPO Homes, and or BPO Tech, may be amended from
time to time as needed. Broker shall provide BPO Homes, and or BPO Tech detailed reports of
activities regarding the Real Estate Services and keep BPO Homes, and or BPO Tech
informed about the current status of all Referrals through our 
Lead Monitoring Platform and any other means necessary to included 
but not limited to Email correspondence, Text correspondence. 
1st Attempt by Broker to be through the BPO Homes, and or BPO Tech Lead Monitoring System.
Upon closing a real estate transaction with a Referral, Broker
agrees to provide BPO Homes, and or BPO Tech  with the closing statement or other
applicable document detailing the transaction no later than
ten (24) Hours prior to the closing date.
`,
        render: false,
      },
      {
        content: `Referral Acceptance by Broker. When BPO Homes, and or BPO Tech informs
Broker and/or one of Broker’s Participating Agents that a
											
Referral is available, Broker directly or indirectly through
one of its Participating Agents will be given the opportunity
to accept or decline the Referral. “Referral Acceptance” is
when Broker or a Participating Agent accepts a Referral via
electronic, written, or verbal acknowledgement BPO Homes, and oro BPO Tech.
Broker acknowledges that its Participating Agents have
authority to accept a Referral on Broker’s behalf and that
such Participating Agent may deliver the Referral
Acceptance on Broker’s behalf and such Referral
Acceptance shall be binding on Broker and its Participating
Agents. By accepting a Referral as described above, Broker
acknowledges and agrees that receipt of the Referral and
any data provided by BPO Homes, and or BPO Tech regarding the Referral is
governed by the terms of this Agreement.
`,
        render: false,
      },
      {
        content: `During Broker’s participation in the
BPO Homes, and or BPO Tech shall provide Broker and its
Participating Agents with a limited, non-exclusive license to
use certain technology for the BPO Homes, and or BPO Tech Partner Agent Program and
Referral management (the “ BPO Homes, and or BPO Tech Platform Tools”)
solely for Referral management monitoring in accordance with the
terms of this Agreement. Broker acknowledges that (1) the
BPO Homes, and or BPO Tech Tools and related information are
protected by intellectual property laws; and (2) except as
expressly granted in this Agreement, neither Broker nor any
of its Participating Agents are acquiring any rights in any
BPO Homes, and or BPO Tech property. Neither Broker nor any its
Participating Agents shall (1) sell, transfer, or disclose the
BPO Homes, and or BPO Tech Platform Tools to other persons or entities; or
(2) provide log-in information or a sublicense to any other
person or entity for use of the BPO Homes, and or BPO Tech Platform Tools.
ACCESS TO BPO Tech Platform TOOLS TO
PROVIDE SERVICES AND THE SERVICES
THEMSELVES ARE “AS IS” WITHOUT WARRANTY OF
ANY KIND, EITHER EXPRESSED OR IMPLIED,
INCLUDING THE IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS FOR A PARTICULAR
PURPOSE.
`,
        render: false,
      },
      {
        content: `In regards to Referral Fees Broker understands and agrees that
BPO Homes, and or BPO Tech has expended significant time and resources to
source, obtain and nurture the Referrals. Should Broker (or
one of its Participating Agents) receive a real estate
											
commission from a closed real estate transaction involving
such Referral during the twenty-four (24) months (the
“Referral Tail Period”) following the date the Referral is
deemed accepted by the Broker or one of its Participating
Agents as evidenced by the Referral Acceptance, Broker
agrees to pay BPO Homes, and or BPO Tech a “Referral Fee” of a minimum of 
20.00% (the “Referral Fee Percentage”) of the Gross Commissions
as compensation for introducing the Broker (and/or one of
its Participating Agents) to the Referral because without
such introduction, whether directly or indirectly, the real
estate transactions may not have occurred. “Gross
Commission” is the amount that a broker is eligible to
receive as stated in the closing document including any
bonuses paid to an agent for client-side real estate
brokerage services and real estate agency services of any
and all real estate transactions (including subsequent lease
commissions on a property sold) involving BPO Homes, and or BPO Tech sourced
Referral for the Referral Tail Period. “Gross Commission”
(i) is not reduced by any discounts or commission reduction
Broker may extend to a Referral; and (ii) excludes any
commissions for other real estate settlement services. The
Referral Fee shall be calculated as the greater of (A) the
Referral Fee Percentage of the actual Gross Commission
received; and (B) the Referral Fee Percentage of 2.0% of
the total sales price of such real estate transactions.
`,
        render: false,
      },
      {
        content: ` In regards to Payment Terms the following applies:
(a) Referral Fees shall be remitted promptly following
the consummation of transaction with such Referral, but in
no event later than ten (7) days following such a transaction.
A copy of the closing statement or other applicable
statement detailing the transaction shall be included for
Referral Fee verification purposes. Payment shall be made
in accordance with the payment instructions attached
hereto as Exhibit B.
(b) Referral Fees owed to BPO Homes, and or BPO Tech are not impacted,
reduced or waived due to any other referral fee, commission
or other payment that the Broker or one of its Participating
Agents may owe to another third party based on BPO Homes, and or BPO Tech
Referral’s real estate transaction.


`,
        render: false,
      },
      {
        content: ` Transfer of Referrals. Broker shall not transfer a
Referral to another broker and/or unaffiliated agent. If
Broker is unable or unwilling to continue with the Referral,

Broker shall advise BPO Homes, and or BPO Tech in writing and BPO Tech 
shall have the right to transfer the Referral to another broker and/or agent.
The Referral Fee is tied to the Referral. The obligation for
Broker to pay Referral Fees under this Agreement is not
subject to one of its affiliate agent’s continued employment
or contractor relationship with Broker and is not waived,
forgiven, or nullified upon the termination of such
relationship. If Broker receives any Gross Commissions in
connection with a Referral during the Referral Tail Period,
BPO Homes, and or BPO Tech is entitled to, and Broker agrees to pay, the applicable
Referral Fee on such Gross Commissions received by
Broker.

`,
        render: false,
      },
      {
        content: `7. Term and Termination
(a) This Agreement shall commence on the Effective
Date and shall continue until it is terminated by either Broker
Or BPO Homes and o by, BPO Tech (the “Term”). 
(b) For Broker to terminate the Agreement, notice must
be provided in writing to BPO Homes, and or BPO Tech at least (30) days prior to the
desired termination date. BPO Homes, and or  BPO Tech retains the right to terminate
this Agreement immediately with or without cause upon
notice to Broker.
(c) If the Agreement is terminated, Broker agrees to
pay BPO Homes, and or BPO Tech the Referral Fees upon close and funding of any
Referral that BPO Homes, and or BPO Tech provided to Broker or one of Broker’s
Participating Agents through the conclusion of any
applicable Referral Tail Period.
(d) Broker affirms that the payment obligations set forth
in Section 7 shall survive any termination of this Agreement
and shall continue until the expiration of any applicable
Referral Tail Period.
`,
        render: false,
      },
      {
        content: `8. Representations and Warranties of Broker and BPO Tech.
Broker and BPO Homes, and or BPO Tech hereby represent and warrant to each
other as follows:
(a) BPO Homes, and or BPO Tech is 100% owned by BPO Homes Inc a licensed Broker 
in the state of California and Broker and each of its Participating Agents are licensed real
estate brokers/agents in each state where they perform
Real Estate Services. Each Party shall maintain such
licenses in good standing throughout the duration of this
Agreement and any Referral Tail Period. Each Party shall
immediately notify the other Party if it receives a regulatory
complaint against such Party or one of Broker’s
Participating Agents or if Broker or one of Broker’s
Participating Agents is not in good standing with any
licensing authority, as applicable.
(b) Any Party disclosing data to another Party pursuant
to this Agreement warrants that such disclosure is made in
compliance with all applicable laws.
`,
        render: false,
      },
      {
        content: `9.  Representation of Broker. Broker and each of its
Agents hereby represent and warrant BPO Tech as follows:
(a) Broker is an equal opportunity employer that does
not and will not discriminate in employment and personnel
practices (including hiring, transferring and promotion
practices) on the basis of race, sex, age, disability, religion,
national origin, color, sexual orientation, or any other basis
or characteristic prohibited by law. There are and have been
no unfair labor practice complaints against Broker in
connection with its business which materially affect the
business of the Broker.
(b) Broker will comply with all applicable laws and
regulations in performing this Agreement, including without
limitation the limits and restrictions on payments for referrals
for other real estate settlement services under applicable
Law. Broker and each of its Participating Agents shall
comply with all fair housing laws, rules, and regulations
including without limitation the Fair Housing Act, Title VIII
Civil Rights Act of 1968, 42 USC 3600, et seq.
(c) Broker understands and agrees that BPO Homes nor 
BPO Tech do not have any responsibility to provide any services to Broker or
any of its Participating Agents beyond the introduction to the
Referral.

`,
        render: false,
      },
      {
        content: `10. 10. Communication and Notices. All notices must be in
writing and will be deemed given only when sent by first
class mail (return receipt requested), hand-delivered or sent
by documented overnight delivery service to the Party to
whom the notice is directed, at its address indicated on the
signature page for Broker and Agent and to the following for
BPO Homes and or BPO Tech:

6920 Santa Teresa Blvd Suite 208
San Jose Ca 95119

Any Party may change its address for notices by sending a
change of address notice using this notice procedure.
`,
        render: false,
      },
      {
        content: `11. Confidentiality; Data Privacy; Indemnification; and
Dispute Resolution. Exhibit A: Confidentiality; Data Privacy;
Indemnification; and Dispute Resolution is incorporated
Herein.
`,
        render: false,
      },
      {
        content: `12. By signing this agreement Broker agrees to allow 
BPO Homes, and or BPO Tech reserve the right to receive compensation & for BPO Homes, and or BPO Tech to pay BPO Homes and or BPO Tech Partner Agent directly for BPO Report services Rendered. 
Upon Brokers unwillingness to sign this agreement and upon Agents sole independent signing of this agreement earned BPO Reports fees are to then be paid directly to Broker which will be subject to a Broker in which a Commission split may apply between Broker & Agent. Any such earned BPO Report Fee for BPO Report Services rendered will be for the completion of any such BPO Reports.
`,
        render: false,
      },
      {
        content: `13. Upon Agents signing or non signing of this Agreement and Brokers non signing of this agreement Broker and Agent are still obligated to pay compensation to BPO Homes, and or BPO Tech for referrals at a rate 20% of the the Total Gross commission of the Total Property Purchase price. This Agreement and the Terms of use found on bpohomes.com & bpotech.io
Upon Broker and or Agents non signing BPO Homes, and or BPO Tech compensation is to be paid directly to Broker for completion of such BPO Reports.
`,
        render: false,
      },
      {
        content: `14. General Provisions.
(a) Cooperative Brokerage Referral Agreement. This
Agreement is a cooperative brokerage referral agreement
between BPO Homes, and or BPO Tech , and or and Broker pursuant to 12 U.S.C. §
2607(c)(3) and 12 CFR § 1024.14(g)(1)(v).
(b) Assignment. This Agreement, including all
amendments and exhibits, shall inure to the benefit of and
be binding upon the successors and permitted assigns of
the Parties. BPO Homes, and or BPO Tech may assign its 
rights or obligations without the consent of the Broker. Broker may
not assign its rights or obligations hereunder without the prior written 
permission of BPO Homes, and or BPO Tech , and any attempted 
assignment shall be void.
(c) Entire Agreement. This Agreement constitutes the
entire agreement between the Parties and supersedes all
prior understandings and agreements, written or oral, with
respect to the subject matter hereof. This Agreement may
be amended or modified only by an instrument signed by
the party against whom enforcement of that waiver is
sought.
(d) Governing Law; Construction. This Agreement shall
be governed by Texas law, without regard to principles of
conflicts of law, and shall be interpreted as having been
jointly drafted by the Parties.
(e) Exclusive Jurisdiction. Subject to and without
waiving Exhibit A, Section A-4 (Dispute Resolution), if any
suit or other action is brought that arises from or is related
to this Agreement, it shall be brought exclusively in Travis
County, Texas. However, if suit is brought by a third party
against a Party regarding which the terms of the
Indemnification provisions herein would apply, that sued
Party may implead or counterclaim against the other Party
in that action, even if not in Travis County, Texas, in order
to enforce the terms of such indemnification. In any action
brought under this Agreement, each party shall bear its own
costs and expenses, including attorneys’ fees.






                                                                                                                      
(f) Survival. The Parties shall continue to be bound by
those provisions of this Agreement which by their nature
survive expiration or termination, including but not limited to:
Section 1 through 7, 8(c), 8(d), Section 9 through 13 and
Exhibit A.
(g) Media. Broker may not, without the prior written
consent of BPO Homes, and or BPO Tech , issue any media release, public
announcement, or make any public disclosures relating to
this Agreement, including, without limitation, promotional or
marketing material, but not including any announcement
intended solely for internal distribution by a Party, or any
disclosure required by applicable law. Notwithstanding the
forgoing, BPO Homes, and or BPO Tech has the right to use, without additional
consideration, Broker’s and any of its Participating Agents’
testimonials, images, logos, likeness, or voice to market
BPO Homes, and or BPO Tech services, brand, products, or affiliates. 
Broker and/or Agent further consent that Broker’s and each of its
Participating Agent’s name and identity may be revealed
therein or by descriptive text or commentary.
(h) Waiver. Any waiver by a Party of any provision of
this Agreement shall not imply a subsequent waiver of that
or any other provision. Any failure to enforce strict
performance of any provision of this Agreement shall not be
construed as a waiver or relinquishment of the right to
enforce strict performance on any future occasion.
(i) Independent Parties. The Parties acknowledge that
Their relationship is that of independent contractors. 
Nothing contained in this Agreement shall be deemed to create a
joint venture or partnership relationship. Broker
acknowledges that Broker and its Participating Agents are
not BPO Homes, and or BPO Tech employees. Broker is required to 
pay and it is Broker’s responsibility to pay all applicable taxes including
federal and state income tax on any fees that are paid to
Broker by a Referral. Broker will also be responsible for all
expenses and payments related to activities detailed within
this Agreement including compensating Broker’s
Participating Agents. 





											 

The Parties enter into this Agreement
as independent contractors to each other and nothing in this Agreement is intended to create or shall be construed as creating an employer-employee relationship or a
partnership, agency, or franchise or joint venture relationship among or between the Parties or among or between one Party and the other Party’s Representatives. (j) Counterparts. This Agreement may be executed in two or more counterparts, each of which shall be deemed
an original, but all of which together shall constitute one and the same instrument.

By their signatures below, the parties to this Agreement
have executed this Agreement as of the Effective Date.

BPO Homes Inc :
DBA BPO Homes & BPO Tech
Title: Broker
Broker Name: Joban Brown
Title: Broker Officer
Date Signed:
Address:6920 Santa Teresa Blvd Suite 208 San Jose Ca 95119
Phone:888.616.5270
Email:contracts@bpohomes.com
Agent License State:CA
Agent License Number:01848263

Agent Name:
Agent Phone:
Agent Email:
Agent License Number:
Brokerage Name:
Brokerage Address:
Brokerage Phone:
Brokerage Email:
Broker License State:
Date Signed:

										
Exhibit A: Confidentiality; Data Privacy;
Indemnification and Dispute Resolution
A-1. Confidential Information.
(a) Each Party will maintain the confidentiality of any
information that is received from the other Party and is
confidential. Neither Party shall use any other Party’s
Confidential Information except as permitted by this
Agreement. Each Party shall (i) use the other Party’s
Confidential Information only for the purpose of
performing its obligations under this Agreement, (ii) hold
the other Party’s Confidential Information in confidence,
and (iii) not disclose such Confidential Information to any
persons other than those employees and/or agents who
have a business-related need to have access to such
Confidential Information in furtherance of the limited
purposes of this Agreement and who have been
apprised of, and agree in writing to maintain, the
confidential nature of such information in accordance
with the terms of this Agreement. Each Party shall be
responsible for the breach of this Agreement by any of
its employees and/or agents. “Confidential
Information” means, without limitation, (i) the
information constituting the Referral, including nonpublic
personal information of any consumer, (ii) nonpublic
information that (A) a Party designates as being
confidential, (B) under the circumstances surrounding
disclosure should be treated as confidential, or (C) by
reason of its nature would be treated as confidential by
a reasonable person; (iii) information that is subject to
privacy or confidentiality restrictions to under any law or
regulation, including Title V, Subtitle A of the Gramm-
Leach-Bliley Act or any of its amendments; and (iv)
information that is subject to privacy or confidentiality
restrictions under the Party's privacy policy.
“Confidential Information” includes, without limitation,
information in tangible or intangible form relating to
and/or including a Party’s business policies, trade
secrets or practices, financial data, customer data, and
information received from third parties that a Party is
obligated to treat it as confidential. BPO Homes, and or BPO Tech Confidential
Information shall also include the existence of this
Agreement and its content.
(b) Broker shall comply with all privacy and data
											
protection laws, rules, and regulations applicable to the
information disclosed by BPO Homes, and or BPO Tech 
pursuant to this Agreement or in connection with any Real Estate
Services.
A-2. General Indemnification. Broker shall defend,
indemnify and hold BPO Homes, and or BPO Tech , its parents, subsidiaries, and
affiliated companies, and its and their respective
employees, officers, directors, shareholders, and agents
(each, an “BPO Homes, and or BPO Tech  lndemnitee”) harmless from and against
all claims, damages, losses, suits, actions, demands,
proceedings, expenses, and liabilities of any kind,
(including reasonable attorneys’ fees incurred and/or
those necessary to successfully establish the right to
indemnification) threatened, asserted or filed
(collectively, “Claims”) against any BPO Homes, and or BPO Tech lndemnitee, to
the extent that such Claims arise out of or relate to
Broker’s (and its Participating Agents’) duties or
responsibilities as contemplated under this Agreement
involving (i) bodily injury or death to any person, (ii) loss,
disappearance, or damage to property, (iii) any breach
or alleged breach of any warranty or representation
made by Broker under this Agreement, (v) compliance
with applicable law and/or (vi) any act or omission to act
of Broker or its Participating Agents, except to the
comparative extent that such Claims result from the
gross negligence or willful acts of BPO Homes, and or BPO Tech .
A-3. LIMITATION OF LIABILITY. EXCLUDING
INDEMNIFICATION OBLIGATIONS UNDER SECTION
A-2 ABOVE, MATTERS INVOLVING CLAIMS OF
GROSS NEGLIGENCE, FRAUD OR WILLFUL
MISCONDUCT, VIOLATIONS OF APPLICABLE LAW
OR DAMAGES ARISING FROM BREACH OF A
PARTY’S CONFIDENTIALITY OBLIGATIONS,
NEITHER PARTY SHALL BE LIABLE TO THE OTHER,
REGARDLESS OF THE FORM OF ACTION,
WHETHER IN CONTRACT, TORT OR OTHERWISE,
FOR ANY LOST PROFITS, BUSINESS
INTERRUPTION, OR FOR ANY INDIRECT,
INCIDENTAL, SPECIAL, CONSEQUENTIAL,
EXEMPLARY OR PUNITIVE DAMAGES ARISING
UNDER OR RELATING TO THIS AGREEMENT, EVEN
IF SUCH PARTY HAS BEEN ADVISED OF THE
POSSIBILITY OF SUCH DAMAGES OR LIABILITY.
											
A-4. Dispute Resolution.
(a) Any dispute, claim or controversy arising out of
or relating to this Agreement or the breach, termination,
enforcement, interpretation or validity thereof, including
the determination of the scope or applicability of this
agreement to arbitrate (each, a “Dispute”), shall be
determined by arbitration in San Jose, California before one
arbitrator. The arbitration shall be administered by pursuant to its Comprehensive Arbitration Rules and Procedures. Judgment on the Award may be entered in
any court having jurisdiction. This clause shall not
preclude parties from seeking provisional remedies in aid
of arbitration from a court of appropriate jurisdiction.
(b) Prior to initiating arbitration under Section A-4(a)
above, Broker and BPO Homes, and or BPO Tech shall negotiate in good faith to
settle such Dispute for a period of thirty (30) days (the
“Initial Negotiation Period”). If the Dispute cannot be
settled through negotiation during the Initial Negotiation
Period, Broker and BPO Homes, and or BPO Tech agree that any and all disputes,
claims or controversies arising out of or relating to this
Agreement shall then be submitted to arbitrated, or its
successor, for mediation, and if the matter is not resolved
through mediation, then it shall be fully arbitrated, or
its successor, for final and binding arbitration pursuant to
the clause set forth in Section A-4(f) below.
(c) After the end of the Initial Negotiation Period,
either BPO Homes, and or BPO Tech or Broker may commence mediation by
providing and the other party a written request
for mediation, setting forth the subject of the dispute and
the relief requested.
(d) Broker and BPO Homes, and or BPO Tech will cooperate with and
with one another in selecting a mediator from the 
panel of neutrals and in scheduling the mediation
proceedings. Broker and BPO Homes, and or BPO Tech agree that they will
participate in the mediation in good faith and that they
will share equally in its costs.
(e) All offers, promises, conduct and statements,
whether oral or written, made in the course of the
mediation by any of Broker or BPO Homes, and or BPO Tech , their agents,
employees, experts and attorneys, and by the mediator
are confidential, privileged and
inadmissible for any purpose, including impeachment, in
any arbitration or other proceeding involving the parties;
provided that evidence that is otherwise admissible or
											

discoverable shall not be rendered inadmissible or non-
discoverable as a result of its use in the mediation.

(f) Either party may initiate arbitration with respect
to the matters submitted to mediation by filing a written
demand for arbitration at any time following the initial
mediation session or at any time following forty-five (45)
days from the date of filing the written request for
mediation, whichever occurs first ("Earliest Initiation
Date"). The mediation may continue after the
commencement of arbitration if the parties so desire.
(g) At no time prior to the Earliest Initiation Date
shall either side initiate an arbitration related to this
Agreement except to pursue a provisional remedy that is
authorized by law or by or by agreement of
the parties. However, this limitation is inapplicable to a
party if the other party refuses to comply with the
requirements of Section A-4(d) above.
(h) All applicable statutes of limitation and defenses
based upon the passage of time shall be tolled until 15
days after the Earliest Initiation Date. The parties will
take such action, if any, required to effectuate such
tolling.
(i) Broker and BPO Homes, and or BPO Tech agree and 
understand that the arbitrator shall have all powers provided by law and by
this Agreement. Each of Broker and BPO Homes, and or BPO Tech shall bear its
own costs and expenses, including attorney’s fees, in
connection with any arbitration or mediation proceeding.

Exhibit B: Payment Instructions
Referral Fee Checks & Closing
Statements Remittance Address
BPO Homes
6920 Santa Teresa Blvd Suite 208
San Jose Ca 95119
**Deposits received by courier may not post same day**
`,
        render: false,
      },
      {
        content: `This Master Broker Referral Agreement (“Agreement”) is
made and entered into as of the date of the last signature
above (the “Effective Date”) by and among BPO Homes Inc
& BPO Tech Inc are California Incorporated Corporations 
(“BPO Homes”) & (BPO Tech), and the real
estate broker executing this Agreement (“Broker”). All
references to “Broker” in this Agreement shall include all
agents affiliated with Broker who have onboarded to
participate in the BPO Homes, BPO Tech Partner Agent 
Program (each“Participating Agent”) during the term of this Agreement
and/or during any Referral Period. BPO Homes, BPO Tech and Broker are
referred to in this Agreement individually as a “Party” and
collectively as the “Parties”. As point of reference
This agreement with Exhibits included are a Total of 14 Pages in length
`,
        render: false,
      },
    ],
  },
  {
    name: "AGREEMENT",
    subs: [
      {
        content: `NOW, THEREFORE, the Parties agree as follows:
BPO Homes,BPO Tech Partner Agent Program.
(a) Subject to the terms and conditions of this
Agreement, BPO Homes, BPO Tech agrees to make available and Broker
agrees to participate in the BPO Homes, BPO Tech Partner Agent Program, 
BPO Homes, BPO Tech national network of real estate brokers and agents.
(b) Broker enters into this Agreement on behalf of itself
and all of its Participating Agents and understands and
accepts that Broker is jointly and severally responsible with
its agents for any Referral Fees payable to BPO Homes, and or BPO Tech.
(c) Broker shall participate in the BPO Homes, and o  BPO Tech Partner Agent Program
on a non-exclusive basis for the purpose of assisting
consumers referred by BPO Homes, and or BPO Tech to Broker and/or one of its
agents (each, a “Referral”) with real estate transactions
(“Real Estate Services”), which services may include (i)
placing a Referral’s home on the multiple listing service
and/or other listing databases in which Broker participates
and assisting Referrals in selling property; and (ii) helping
                                                                                                                          
Referrals find a suitable property to purchase or lease.
(d) By Broker participating in the BPO Homes, and or BPO Tech Partner Agent Program,
BPO Homes, and or BPO Tech agree to make best effort to connect Broker with one
or more Referral(s) to see if Real Estate Services can be
provided.
(e) BPO Homes, and or BPO Tech will own all right, title, and interest (including,
without limitation, all copyrights, trade secrets, patents,
trademarks, and any other intellectual property or
proprietary rights) in and to any Referrals. As the owner of
the Referrals,  BPO Homes, and or BPO Tech retains the right to use the Referrals and
Referral data as it deems fit.
(f) By participating in the BPO Homes, and or BPO Tech Partner Agent Program and
accepting Referrals, Broker agrees: (i) to maintain the
confidentiality of the Referral’s information whether
provided by BPO Homes, and or BPO Tech or the Referral to the extent required by
any law or regulation, including as required by BPO Tech
privacy policy, including the California Consumer Privacy
Act, as applicable; (ii) that  BPO Homes, and or BPO Tech responsibility is solely to
provide Broker with contact and background information
about the Referral and to monitor Broker’s delivery of Real
Estate Services to those Referrals and that BPO Homes, and or  BPO Tech does not
have any responsibility to provide real estate brokerage
services to any Referrals; and (iii) to not interfere with
business relationships of Referrals and any settlement
service providers BPO Homes, and or BPO Tech have introduced such Referral.
(g) As more particularly set forth in the BPO Homes, and or BPO Tech Partner Agents
Terms of Us methods of Referral Contact may be but not limited to the following (phone, email, and or by BPO Homes, and or BPO Tech Platform Tools, etc. ) in which BPO Homes, and or BPO Tech Terms of use established by BPO Homes, and or BPO Tech, may be amended from
time to time as needed. Broker shall provide BPO Homes, and or BPO Tech detailed reports of
activities regarding the Real Estate Services and keep BPO Homes, and or BPO Tech
informed about the current status of all Referrals through our 
Lead Monitoring Platform and any other means necessary to included 
but not limited to Email correspondence, Text correspondence. 
1st Attempt by Broker to be through the BPO Homes, and or BPO Tech Lead Monitoring System.
Upon closing a real estate transaction with a Referral, Broker
agrees to provide BPO Homes, and or BPO Tech  with the closing statement or other
applicable document detailing the transaction no later than
ten (24) Hours prior to the closing date.

`,
        render: false,
      },
      {
        content: `2. Referral Acceptance by Broker. When BPO Homes, and or BPO Tech informs
Broker and/or one of Broker’s Participating Agents that a
											 
Referral is available, Broker directly or indirectly through
one of its Participating Agents will be given the opportunity
to accept or decline the Referral. “Referral Acceptance” is
when Broker or a Participating Agent accepts a Referral via
electronic, written, or verbal acknowledgement BPO Homes, and or BPO Tech.
Broker acknowledges that its Participating Agents have
authority to accept a Referral on Broker’s behalf and that
such Participating Agent may deliver the Referral
Acceptance on Broker’s behalf and such Referral
Acceptance shall be binding on Broker and its Participating
Agents. By accepting a Referral as described above, Broker
acknowledges and agrees that receipt of the Referral and
any data provided by BPO Homes, and or BPO Tech regarding the Referral is
governed by the terms of this Agreement.

`,
        render: false,
      },
      {
        content: `3. During Broker’s participation in the
BPO Homes, and or BPO Tech shall provide Broker and its
Participating Agents with a limited, non-exclusive license to
use certain technology for the BPO Homes, and or BPO Tech Partner Agent Program and
Referral management (the “ BPO Homes, and or BPO Tech Platform Tools”)
solely for Referral management monitoring in accordance with the
terms of this Agreement. Broker acknowledges that (1) the
BPO Homes, and or BPO Tech Tools and related information are
protected by intellectual property laws; and (2) except as
expressly granted in this Agreement, neither Broker nor any
of its Participating Agents are acquiring any rights in any
BPO Homes, and or BPO Tech property. Neither Broker nor any its
Participating Agents shall (1) sell, transfer, or disclose the
BPO Homes, and or BPO Tech Platform Tools to other persons or entities; or
(2) provide log-in information or a sublicense to any other
person or entity for use of the BPO Homes, and or BPO Tech Platform Tools.
ACCESS TO BPO Tech Platform TOOLS TO
PROVIDE SERVICES AND THE SERVICES
THEMSELVES ARE “AS IS” WITHOUT WARRANTY OF
ANY KIND, EITHER EXPRESSED OR IMPLIED,
INCLUDING THE IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS FOR A PARTICULAR
PURPOSE.
`,
        render: false,
      },
      {
        content: `4. In regards to Referral Fees Broker understands and agrees that
BPO Homes, and or BPO Tech has expended significant time and resources to
source, obtain and nurture the Referrals. Should Broker (or
one of its Participating Agents) receive a real estate
											
commission from a closed real estate transaction involving
such Referral during the twenty-four (24) months (the
“Referral Tail Period”) following the date the Referral is
deemed accepted by the Broker or one of its Participating
Agents as evidenced by the Referral Acceptance, Broker
agrees to pay BPO Homes, and or BPO Tech a “Referral Fee” of a minimum of 
20.00% (the “Referral Fee Percentage”) of the Gross Commissions
as compensation for introducing the Broker (and/or one of
its Participating Agents) to the Referral because without
such introduction, whether directly or indirectly, the real
estate transactions may not have occurred. “Gross
Commission” is the amount that a broker is eligible to
receive as stated in the closing document including any
bonuses paid to an agent for client-side real estate
brokerage services and real estate agency services of any
and all real estate transactions (including subsequent lease
commissions on a property sold) involving BPO Homes, and or BPO Tech sourced
Referral for the Referral Tail Period. “Gross Commission”
(i) is not reduced by any discounts or commission reduction
Broker may extend to a Referral; and (ii) excludes any
commissions for other real estate settlement services. The
Referral Fee shall be calculated as the greater of (A) the
Referral Fee Percentage of the actual Gross Commission
received; and (B) the Referral Fee Percentage of 2.0% of
the total sales price of such real estate transactions.
`,
        render: false,
      },
      {
        content: `5. In regards to Payment Terms the following applies:
(a) Referral Fees shall be remitted promptly following
the consummation of transaction with such Referral, but in
no event later than ten (7) days following such a transaction.
A copy of the closing statement or other applicable
statement detailing the transaction shall be included for
Referral Fee verification purposes. Payment shall be made
in accordance with the payment instructions attached
hereto as Exhibit B.
(b) Referral Fees owed to BPO Homes, and or BPO Tech are not impacted,
reduced or waived due to any other referral fee, commission
or other payment that the Broker or one of its Participating
Agents may owe to another third party
`,
        render: false,
      },
      {
        content: `6. Transfer of Referrals. Broker shall not transfer a
Referral to another broker and/or unaffiliated agent. If
Broker is unable or unwilling to continue with the Referral,

Broker shall advise BPO Homes, and or BPO Tech in writing and BPO Tech 
shall have the right to transfer the Referral to another broker and/or agent.
The Referral Fee is tied to the Referral. The obligation for
Broker to pay Referral Fees under this Agreement is not
subject to one of its affiliate agent’s continued employment
or contractor relationship with Broker and is not waived,
forgiven, or nullified upon the termination of such
relationship. If Broker receives any Gross Commissions in
connection with a Referral during the Referral Tail Period,
BPO Homes, and or BPO Tech is entitled to, and Broker agrees to pay, the applicable
Referral Fee on such Gross Commissions received by
Broker.
`,
        render: false,
      },
      {
        content: `7. Term and Termination
(a) This Agreement shall commence on the Effective
Date and shall continue until it is terminated by either Broker
Or BPO Homes and o by, BPO Tech (the “Term”). 
(b) For Broker to terminate the Agreement, notice must
be provided in writing to BPO Homes, and or BPO Tech at least (30) days prior to the
desired termination date. BPO Homes, and or  BPO Tech retains the right to terminate
this Agreement immediately with or without cause upon
notice to Broker.
(c) If the Agreement is terminated, Broker agrees to
pay BPO Homes, and or BPO Tech the Referral Fees upon close and funding of any
Referral that BPO Homes, and or BPO Tech provided to Broker or one of Broker’s
Participating Agents through the conclusion of any
applicable Referral Tail Period.
(d) Broker affirms that the payment obligations set forth
in Section 7 shall survive any termination of this Agreement
and shall continue until the expiration of any applicable
Referral Tail Period.

						



`,
        render: false,
      },
      {
        content: `8. Representations and Warranties of Broker and BPO Tech.
Broker and BPO Homes, and or BPO Tech hereby represent and warrant to each
other as follows:
(a) BPO Homes, and or BPO Tech is 100% owned by BPO Homes Inc a licensed Broker 
in the state of California and Broker and each of its Participating Agents are licensed real
estate brokers/agents in each state where they perform
Real Estate Services. Each Party shall maintain such
licenses in good standing throughout the duration of this
Agreement and any Referral Tail Period. Each Party shall
immediately notify the other Party if it receives a regulatory
complaint against such Party or one of Broker’s
Participating Agents or if Broker or one of Broker’s
Participating Agents is not in good standing with any
licensing authority, as applicable.
(b) Any Party disclosing data to another Party pursuant
to this Agreement warrants that such disclosure is made in
compliance with all applicable laws.

`,
        render: false,
      },
      {
        content: `9. Representation of Broker. Broker and each of its
Agents hereby represent and warrant BPO Tech as follows:
(a) Broker is an equal opportunity employer that does
not and will not discriminate in employment and personnel
practices (including hiring, transferring and promotion
practices) on the basis of race, sex, age, disability, religion,
national origin, color, sexual orientation, or any other basis
or characteristic prohibited by law. There are and have been
no unfair labor practice complaints against Broker in
connection with its business which materially affect the
business of the Broker.
(b) Broker will comply with all applicable laws and
regulations in performing this Agreement, including without
limitation the limits and restrictions on payments for referrals
for other real estate settlement services under applicable
Law. Broker and each of its Participating Agents shall
comply with all fair housing laws, rules, and regulations
including without limitation the Fair Housing Act, Title VIII
Civil Rights Act of 1968, 42 USC 3600, et seq.
(c) Broker understands and agrees that BPO Homes nor 
BPO Tech do not have any responsibility to provide any services to Broker or
any of its Participating Agents beyond the introduction to the
Referral.
`,
        render: false,
      },
      {
        content: `10. Communication and Notices. All notices must be in
writing and will be deemed given only when sent by first
class mail (return receipt requested), hand-delivered or sent
by documented overnight delivery service to the Party to
whom the notice is directed, at its address indicated on the
signature page for Broker and Agent and to the following for
BPO Homes and or BPO Tech:

6920 Santa Teresa Blvd Suite 208
San Jose Ca 95119

Any Party may change its address for notices by sending a
change of address notice using this notice procedure.
`,
        render: false,
      },
      {
        content: `11. Confidentiality; Data Privacy; Indemnification; and
Dispute Resolution. Exhibit A: Confidentiality; Data Privacy;
Indemnification; and Dispute Resolution is incorporated
Herein.
`,
        render: false,
      },
      {
        content: `12. By signing this agreement Broker agrees to allow 
BPO Homes, and or BPO Tech reserve the right to receive compensation & for BPO Homes, and or BPO Tech to pay BPO Homes and or BPO Tech Partner Agent directly for BPO Report services Rendered. 
Upon Brokers unwillingness to sign this agreement and upon Agents sole independent signing of this agreement earned BPO Reports fees are to then be paid directly to Broker which will be subject to a Broker in which a Commission split may apply between Broker & Agent. Any such earned BPO Report Fee for BPO Report Services rendered will be for the completion of any such BPO Reports.

`,
        render: false,
      },
      {
        content: `13. Upon Agents signing or non signing of this Agreement and Brokers non signing of this agreement Broker and Agent are still obligated to pay compensation to BPO Homes, and or BPO Tech for referrals at a rate 20% of the the Total Gross commission of the Total Property Purchase price. This Agreement and the Terms of use found on bpohomes.com & bpotech.io
Upon Broker and or Agents non signing BPO Homes, and or BPO Tech compensation is to be paid directly to Broker for completion of such BPO Reports.


`,
        render: false,
      },
      {
        content: `14. General Provisions.
(a) Cooperative Brokerage Referral Agreement. This
Agreement is a cooperative brokerage referral agreement
between BPO Homes, and or BPO Tech , and or and Broker pursuant to 12 U.S.C. §
2607(c)(3) and 12 CFR § 1024.14(g)(1)(v).
(b) Assignment. This Agreement, including all
amendments and exhibits, shall inure to the benefit of and
be binding upon the successors and permitted assigns of
the Parties. BPO Homes, and or BPO Tech may assign its 
rights or obligations without the consent of the Broker. Broker may
not assign its rights or obligations hereunder without the prior written 
permission of BPO Homes, and or BPO Tech , and any attempted 
assignment shall be void.
(c) Entire Agreement. This Agreement constitutes the
entire agreement between the Parties and supersedes all
prior understandings and agreements, written or oral, with
respect to the subject matter hereof. This Agreement may
be amended or modified only by an instrument signed by
the party against whom enforcement of that waiver is
sought.
(d) Governing Law; Construction. This Agreement shall
be governed by Texas law, without regard to principles of
conflicts of law, and shall be interpreted as having been
jointly drafted by the Parties.
(e) Exclusive Jurisdiction. Subject to and without
waiving Exhibit A, Section A-4 (Dispute Resolution), if any
suit or other action is brought that arises from or is related
to this Agreement, it shall be brought exclusively in Travis
County, Texas. However, if suit is brought by a third party
against a Party regarding which the terms of the
Indemnification provisions herein would apply, that sued
Party may implead or counterclaim against the other Party
in that action, even if not in Travis County, Texas, in order
to enforce the terms of such indemnification. In any action
brought under this Agreement, each party shall bear its own
costs and expenses, including attorneys’ fees.






                                                                                                                        
(f) Survival. The Parties shall continue to be bound by
those provisions of this Agreement which by their nature
survive expiration or termination, including but not limited to:
Section 1 through 7, 8(c), 8(d), Section 9 through 13 and
Exhibit A.
(g) Media. Broker may not, without the prior written
consent of BPO Homes, and or BPO Tech , issue any media release, public
announcement, or make any public disclosures relating to
this Agreement, including, without limitation, promotional or
marketing material, but not including any announcement
intended solely for internal distribution by a Party, or any
disclosure required by applicable law. Notwithstanding the
forgoing, BPO Homes, and or BPO Tech has the right to use, without additional
consideration, Broker’s and any of its Participating Agents’
testimonials, images, logos, likeness, or voice to market
BPO Homes, and or BPO Tech services, brand, products, or affiliates. 
Broker and/or Agent further consent that Broker’s and each of its
Participating Agent’s name and identity may be revealed
therein or by descriptive text or commentary.
(h) Waiver. Any waiver by a Party of any provision of
this Agreement shall not imply a subsequent waiver of that
or any other provision. Any failure to enforce strict
performance of any provision of this Agreement shall not be
construed as a waiver or relinquishment of the right to
enforce strict performance on any future occasion.
(i) Independent Parties. The Parties acknowledge that
Their relationship is that of independent contractors. 
Nothing contained in this Agreement shall be deemed to create a
joint venture or partnership relationship. Broker
acknowledges that Broker and its Participating Agents are
not BPO Homes, and or BPO Tech employees. Broker is required to 
pay and it is Broker’s responsibility to pay all applicable taxes including
federal and state income tax on any fees that are paid to
Broker by a Referral. Broker will also be responsible for all
expenses and payments related to activities detailed within
this Agreement including compensating Broker’s
Participating Agents. 





										

The Parties enter into this Agreement
as independent contractors to each other and nothing in this Agreement is intended to create or shall be construed as creating an employer-employee relationship or a
partnership, agency, or franchise or joint venture relationship among or between the Parties or among or between one Party and the other Party’s Representatives. (j) Counterparts. This Agreement may be executed in two or more counterparts, each of which shall be deemed
an original, but all of which together shall constitute one and the same instrument.

By their signatures below, the parties to this Agreement
have executed this Agreement as of the Effective Date.

BPO Homes Inc :
DBA BPO Homes & BPO Tech
Title: Broker
Broker Name: Joban Brown
Title: Broker Officer
Date Signed:
Address:6920 Santa Teresa Blvd Suite 208 San Jose Ca 95119
Phone:888.616.5270
Email:contracts@bpohomes.com
Agent License State:CA
Agent License Number:01848263
Agent Name:
Agent Signature:
Agent Phone:
Agent Email:
Agent License Number:
Brokerage Name:
Brokerage Address:
Brokerage Phone:
Brokerage Email:
Broker License State:
Date Signed:


`,
        render: false,
      },
      {
        content: `Exhibit A: Confidentiality; Data Privacy;
Indemnification and Dispute Resolution
A-1. Confidential Information.
(a) Each Party will maintain the confidentiality of any
information that is received from the other Party and is
confidential. Neither Party shall use any other Party’s
Confidential Information except as permitted by this
Agreement. Each Party shall (i) use the other Party’s
Confidential Information only for the purpose of
performing its obligations under this Agreement, (ii) hold
the other Party’s Confidential Information in confidence,
and (iii) not disclose such Confidential Information to any
persons other than those employees and/or agents who
have a business-related need to have access to such
Confidential Information in furtherance of the limited
purposes of this Agreement and who have been
apprised of, and agree in writing to maintain, the
confidential nature of such information in accordance
with the terms of this Agreement. Each Party shall be
responsible for the breach of this Agreement by any of
its employees and/or agents. “Confidential
Information” means, without limitation, (i) the
information constituting the Referral, including nonpublic
personal information of any consumer, (ii) nonpublic
information that (A) a Party designates as being
confidential, (B) under the circumstances surrounding
disclosure should be treated as confidential, or (C) by
reason of its nature would be treated as confidential by
a reasonable person; (iii) information that is subject to
privacy or confidentiality restrictions to under any law or
regulation, including Title V, Subtitle A of the Gramm-
Leach-Bliley Act or any of its amendments; and (iv)
information that is subject to privacy or confidentiality
restrictions under the Party's privacy policy.
“Confidential Information” includes, without limitation,
information in tangible or intangible form relating to
and/or including a Party’s business policies, trade
secrets or practices, financial data, customer data, and
information received from third parties that a Party is
obligated to treat it as confidential. BPO Homes, and or BPO Tech Confidential
Information shall also include the existence of this
Agreement and its content.
(b) Broker shall comply with all privacy and data
											
protection laws, rules, and regulations applicable to the
information disclosed by BPO Homes, and or BPO Tech 
pursuant to this Agreement or in connection with any Real Estate
Services.
A-2. General Indemnification. Broker shall defend,
indemnify and hold BPO Homes, and or BPO Tech , its parents, subsidiaries, and
affiliated companies, and its and their respective
employees, officers, directors, shareholders, and agents
(each, an “BPO Homes, and or BPO Tech  lndemnitee”) harmless from and against
all claims, damages, losses, suits, actions, demands,
proceedings, expenses, and liabilities of any kind,
(including reasonable attorneys’ fees incurred and/or
those necessary to successfully establish the right to
indemnification) threatened, asserted or filed
(collectively, “Claims”) against any BPO Homes, and or BPO Tech lndemnitee, to
the extent that such Claims arise out of or relate to
Broker’s (and its Participating Agents’) duties or
responsibilities as contemplated under this Agreement
involving (i) bodily injury or death to any person, (ii) loss,
disappearance, or damage to property, (iii) any breach
or alleged breach of any warranty or representation
made by Broker under this Agreement, (v) compliance
with applicable law and/or (vi) any act or omission to act
of Broker or its Participating Agents, except to the
comparative extent that such Claims result from the
gross negligence or willful acts of BPO Homes, and or BPO Tech .
A-3. LIMITATION OF LIABILITY. EXCLUDING
INDEMNIFICATION OBLIGATIONS UNDER SECTION
A-2 ABOVE, MATTERS INVOLVING CLAIMS OF
GROSS NEGLIGENCE, FRAUD OR WILLFUL
MISCONDUCT, VIOLATIONS OF APPLICABLE LAW
OR DAMAGES ARISING FROM BREACH OF A
PARTY’S CONFIDENTIALITY OBLIGATIONS,
NEITHER PARTY SHALL BE LIABLE TO THE OTHER,
REGARDLESS OF THE FORM OF ACTION,
WHETHER IN CONTRACT, TORT OR OTHERWISE,
FOR ANY LOST PROFITS, BUSINESS
INTERRUPTION, OR FOR ANY INDIRECT,
INCIDENTAL, SPECIAL, CONSEQUENTIAL,
EXEMPLARY OR PUNITIVE DAMAGES ARISING
UNDER OR RELATING TO THIS AGREEMENT, EVEN
IF SUCH PARTY HAS BEEN ADVISED OF THE
POSSIBILITY OF SUCH DAMAGES OR LIABILITY.
											
A-4. Dispute Resolution.
(a) Any dispute, claim or controversy arising out of
or relating to this Agreement or the breach, termination,
enforcement, interpretation or validity thereof, including
the determination of the scope or applicability of this
agreement to arbitrate (each, a “Dispute”), shall be
determined by arbitration in San Jose, California before one
arbitrator. The arbitration shall be administered by pursuant to its Comprehensive Arbitration Rules and Procedures. Judgment on the Award may be entered in
any court having jurisdiction. This clause shall not
preclude parties from seeking provisional remedies in aid
of arbitration from a court of appropriate jurisdiction.

`,
        render: false,
      },
      {
        content: `(B) Prior to initiating arbitration under Section A-4(a)
above, Broker and BPO Homes, and or BPO Tech shall negotiate in good faith to
settle such Dispute for a period of thirty (30) days (the
“Initial Negotiation Period”). If the Dispute cannot be
settled through negotiation during the Initial Negotiation
Period, Broker and BPO Homes, and or BPO Tech agree that any and all disputes,
claims or controversies arising out of or relating to this
Agreement shall then be submitted to arbitrated, or its
successor, for mediation, and if the matter is not resolved
through mediation, then it shall be fully arbitrated, or
its successor, for final and binding arbitration pursuant to
the clause set forth in Section A-4(f) below.

`,
        render: false,
      },
      {
        content: `(C) After the end of the Initial Negotiation Period,
either BPO Homes, and or BPO Tech or Broker may commence mediation by
providing and the other party a written request
for mediation, setting forth the subject of the dispute and
the relief requested.
`,
        render: false,
      },
      {
        content: `(D) Broker and BPO Homes, and or BPO Tech will cooperate with and
with one another in selecting a mediator from the 
panel of neutrals and in scheduling the mediation
proceedings. Broker and BPO Homes, and or BPO Tech agree that they will
participate in the mediation in good faith and that they
will share equally in its costs.
`,
        render: false,
      },
      {
        content: `(E) All offers, promises, conduct and statements,
whether oral or written, made in the course of the
mediation by any of Broker or BPO Homes, and or BPO Tech , their agents,
employees, experts and attorneys, and by the mediator
are confidential, privileged and
inadmissible for any purpose, including impeachment, in
any arbitration or other proceeding involving the parties;
provided that evidence that is otherwise admissible or
discoverable shall not be rendered inadmissible or non-
discoverable as a result of its use in the mediation.
`,
        render: false,
      },
      {
        content: `(F) Either party may initiate arbitration with respect
to the matters submitted to mediation by filing a written
demand for arbitration at any time following the initial
mediation session or at any time following forty-five (45)
days from the date of filing the written request for
mediation, whichever occurs first ("Earliest Initiation
Date"). The mediation may continue after the
commencement of arbitration if the parties so desire.
`,
        render: false,
      },
      {
        content: `(G) At no time prior to the Earliest Initiation Date
shall either side initiate an arbitration related to this
Agreement except to pursue a provisional remedy that is
authorized by law or by or by agreement of
the parties. However, this limitation is inapplicable to a
party if the other party refuses to comply with the
requirements of Section A-4(d) above.
`,
        render: false,
      },
      {
        content: `(H) All applicable statutes of limitation and defenses
based upon the passage of time shall be tolled until 15
days after the Earliest Initiation Date. The parties will
take such action, if any, required to effectuate such
tolling.
`,
        render: false,
      },
      {
        content: `(I) Broker and BPO Homes, and or BPO Tech agree and 
understand that the arbitrator shall have all powers provided by law and by
this Agreement. Each of Broker and BPO Homes, and or BPO Tech shall bear its
own costs and expenses, including attorney’s fees, in
connection with any arbitration or mediation proceeding.
`,
        render: false,
      },
      {
        content: `Exhibit B: Payment Instructions
Referral Fee Checks & Closing
Statements Remittance Address
BPO Homes
6920 Santa Teresa Blvd Suite 208
San Jose Ca 95119
**Deposits received by courier may not post same day**

`,
        render: false,
      },
    ],
  },
];

const TermsModal = ({ open, onAccept, onClose }) => {
  const [userName, setUserName] = useState("");
  const [hasAgreed, setHasAgreed] = useState(false);
  const [hasScrolledToEnd, setHasScrolledToEnd] = useState(false);
  const [currentPage, setCurrentPage] = useState(1); // 1 for Terms of Service, 2 for Broker Agreement
  const [page1ScrolledToEnd, setPage1ScrolledToEnd] = useState(false);
  const [page2ScrolledToEnd, setPage2ScrolledToEnd] = useState(false);

  const { isDark } = useDarkMode();
  const contentRef = React.useRef(null);

  const handleScroll = (event) => {
    const { scrollTop, scrollHeight, clientHeight } = event?.target;
    const brokerAgreementElement = document.getElementById("broker-agreement");
    const isBrokerAgreementVisible =
      brokerAgreementElement &&
      brokerAgreementElement.offsetTop - 50 <= scrollTop;

    if (isBrokerAgreementVisible && currentPage === 1) {
      setPage1ScrolledToEnd(true);
      setCurrentPage(2);
    } else if (
      scrollTop + clientHeight >= scrollHeight - 10 &&
      currentPage === 2
    ) {
      setPage1ScrolledToEnd(true);
      setPage2ScrolledToEnd(true);
      setHasScrolledToEnd(true);
    }
  };

  const handleAccept = async () => {
    if (
      userName.trim() &&
      hasAgreed &&
      page1ScrolledToEnd &&
      page2ScrolledToEnd
    ) {
      onAccept({
        userName: userName.trim(),
        acceptedAt: new Date().toISOString(),
        termsAccepted: true,
        brokerAgreementAccepted: true,
      });

      await base.post("/core/sign-agreement/", {
        has_agreed_to_terms: true,
        name_of_user: userName?.trim(),
      });

      // Reset states
      setUserName("");
      setHasAgreed(false);
      setHasScrolledToEnd(false);
      setCurrentPage(1);
      setPage1ScrolledToEnd(false);
      setPage2ScrolledToEnd(false);
    }
  };

  const canAccept =
    userName.trim() && hasAgreed && page1ScrolledToEnd && page2ScrolledToEnd;
  const isOnLastPage = currentPage === 2;

  const currentHeaders = currentPage === 1 ? headers : brokerHeaders;

  const TermsRenderer = ({ key, header, isDark }) => {
    return (
      <Box mb={3}>
        <Typography
          variant="h6"
          fontWeight={600}
          mb={1.5}
          sx={{ color: isDark ? "#64b5f6" : "primary.main" }}
        >
          {header.name}
        </Typography>
        {header.subs.map((sub, subIndex) => (
          <Typography
            key={subIndex}
            paragraph
            sx={{
              textAlign: "justify",
              fontSize: 12,
              fontWeight: 300,
              mb: 2,
              pl: sub.render ? 0 : 1,
              color: isDark ? "#ffffff" : "#000000",
              "& b": {
                color: isDark ? "#ffffff" : "#000000",
              },
            }}
          >
            {!sub.render && sub.content}
          </Typography>
        ))}
        {key < currentHeaders.length - 1 && (
          <Divider
            sx={{
              mt: 2,
              mb: 1,
              borderColor: isDark ? "#333333" : "#e0e0e0",
            }}
          />
        )}
      </Box>
    );
  };

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      disableEscapeKeyDown
      sx={{
        "& .MuiDialog-paper": {
          height: "90vh",
          maxHeight: "90vh",
          backgroundColor: isDark ? "#1e1e1e" : "#ffffff",
          color: isDark ? "#ffffff" : "#000000",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: `1px solid ${isDark ? "#333333" : "#e0e0e0"}`,
          backgroundColor: isDark ? "#1e1e1e" : "#ffffff",
          color: isDark ? "#ffffff" : "#000000",
          pb: 1,
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography variant="h5" fontWeight={600} color="inherit">
            Terms of Service Agreement
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", mt: 1, gap: 2 }}>
            <LinearProgress
              variant="determinate"
              value={(currentPage / 2) * 100}
              sx={{
                flex: 1,
                height: 4,
                borderRadius: 2,
                backgroundColor: isDark ? "#333333" : "#e0e0e0",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: isDark ? "#64b5f6" : "primary.main",
                },
              }}
            />
          </Box>
        </Box>
        <IconButton
          onClick={onClose}
          disabled
          sx={{ color: isDark ? "#ffffff" : "#000000" }}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent
        ref={contentRef}
        dividers
        onScroll={handleScroll}
        sx={{
          flex: 1,
          overflowY: "auto",
          padding: "24px",
          backgroundColor: isDark ? "#1e1e1e" : "#ffffff",
          color: isDark ? "#ffffff" : "#000000",
          borderColor: isDark ? "#333333" : "#e0e0e0",
        }}
      >
        <Box mb={2}>
          <Typography
            variant="body2"
            sx={{
              fontStyle: "italic",
              color: isDark ? "#cccccc" : "text.secondary",
            }}
          >
            Please scroll through and read our complete terms of service and
            broker referral agreement before accepting.
          </Typography>
        </Box>

        <Typography
          variant="h4"
          textAlign="center"
          fontWeight={700}
          mb={3}
          sx={{ color: isDark ? "#ffffff" : "#000000" }}
        >
          BPO Tech Terms of Use
        </Typography>

        {currentPage === 1 && (
          <Typography
            paragraph
            sx={{
              textAlign: "justify",
              fontWeight: 300,
              color: isDark ? "#ffffff" : "#000000",
            }}
          />
        )}

        {headers.map((header, index) => (
          <TermsRenderer key={index} header={header} isDark={isDark} />
        ))}

        <Divider id="broker-agreement" sx={{ pt: 2, mb: 2 }} />

        <Typography
          variant="h4"
          textAlign="center"
          fontWeight={700}
          mb={3}
          sx={{ color: isDark ? "#ffffff" : "#000000" }}
        >
          Master Broker Referral Agreement
        </Typography>

        {brokerHeaders.map((header, index) => (
          <TermsRenderer key={index} header={header} isDark={isDark} />
        ))}

        <Box
          sx={{
            position: "sticky",
            bottom: 0,
            backgroundColor: isDark ? "#1e1e1e" : "background.paper",
            pt: 2,
            mt: 4,
            borderTop: "2px solid",
            borderColor: hasScrolledToEnd
              ? isDark
                ? "#4caf50"
                : "success.main"
              : isDark
                ? "#ff9800"
                : "warning.main",
          }}
        >
          <Typography
            variant="body2"
            color={
              hasScrolledToEnd
                ? isDark
                  ? "#4caf50"
                  : "success.main"
                : isDark
                  ? "#ff9800"
                  : "warning.main"
            }
            fontWeight={600}
            textAlign="center"
          >
            {hasScrolledToEnd
              ? "✓ You have read through all terms and the broker agreement. Please provide your details below."
              : "⚠ Please scroll to the bottom to read all terms and broker agreement before accepting."}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          flexDirection: "column",
          gap: 2,
          p: 3,
          borderTop: `1px solid ${isDark ? "#333333" : "#e0e0e0"}`,
          backgroundColor: isDark ? "#1e1e1e" : "#ffffff",
        }}
      >
        {isOnLastPage && (
          <Box sx={{ width: "100%" }}>
            <TextField
              fullWidth
              label="Full Name"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              placeholder="Please enter your full name"
              required
              disabled={!page1ScrolledToEnd || !page2ScrolledToEnd}
              sx={{
                mb: 2,
                "& .MuiInputLabel-root": {
                  color: isDark ? "#cccccc" : "inherit",
                },
                "& .MuiOutlinedInput-root": {
                  color: isDark ? "#ffffff" : "inherit",
                  "& fieldset": {
                    borderColor: isDark ? "#666666" : "inherit",
                  },
                  "&:hover fieldset": {
                    borderColor: isDark ? "#888888" : "inherit",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: isDark ? "#64b5f6" : "inherit",
                  },
                },
                "& .MuiInputBase-input": {
                  color: isDark ? "#ffffff" : "inherit",
                  "&::placeholder": {
                    color: isDark ? "#999999" : "inherit",
                  },
                },
              }}
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={hasAgreed}
                  onChange={(e) => setHasAgreed(e.target.checked)}
                  disabled={!page1ScrolledToEnd || !page2ScrolledToEnd}
                  sx={{
                    color: isDark ? "#cccccc" : "primary.main",
                    "&.Mui-checked": {
                      color: isDark ? "#64b5f6" : "primary.main",
                    },
                  }}
                />
              }
              label={
                <Typography
                  variant="body2"
                  sx={{ color: isDark ? "#ffffff" : "inherit" }}
                >
                  I have read, understood, and agree to be bound by both the
                  Terms of Service and the Master Broker Referral Agreement
                  above.
                </Typography>
              }
            />
          </Box>
        )}

        <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              flex: 1,
              color: isDark ? "#d01111" : "inherit",
              borderColor: isDark ? "#972d2d" : "inherit",
              "&:hover": {
                borderColor: isDark ? "#b40d0d" : "inherit",
                backgroundColor: isDark ? "rgba(255,255,255,0.05)" : "inherit",
              },
              "&.Mui-disabled": {
                color: isDark ? "#666666" : "rgba(0, 0, 0, 0.26)",
                borderColor: isDark ? "#444444" : "rgba(0, 0, 0, 0.12)",
                backgroundColor: isDark
                  ? "rgba(255,255,255,0.02)"
                  : "transparent",
              },
            }}
            // disabled
          >
            Decline
          </Button>

          <Button
            onClick={handleAccept}
            variant="contained"
            disabled={!canAccept}
            sx={{
              flex: 1,
              backgroundColor: canAccept
                ? isDark
                  ? "#4caf50"
                  : "success.main"
                : isDark
                  ? "#424242"
                  : "grey.300",
              color: canAccept ? "#ffffff" : isDark ? "#999999" : "inherit",
              "&:hover": {
                backgroundColor: canAccept
                  ? isDark
                    ? "#45a049"
                    : "success.dark"
                  : isDark
                    ? "#424242"
                    : "grey.300",
              },
              "&.Mui-disabled": {
                backgroundColor: isDark ? "#2a2a2a" : "rgba(0, 0, 0, 0.12)",
                color: isDark ? "#666666" : "rgba(0, 0, 0, 0.26)",
              },
            }}
          >
            Accept All Terms
          </Button>
        </Box>

        {!hasScrolledToEnd && (
          <Typography
            variant="caption"
            textAlign="center"
            sx={{ color: isDark ? "#cccccc" : "text.secondary" }}
          >
            Scroll to the bottom of the{" "}
            {currentPage === 1 ? "terms" : "broker agreement"} to accept
          </Typography>
        )}

        {isOnLastPage && !page1ScrolledToEnd && (
          <Typography
            variant="caption"
            textAlign="center"
            sx={{ color: isDark ? "#f44336" : "error.main" }}
          >
            ⚠ You must read both the Terms of Service and Broker Agreement to
            accept agreement.
          </Typography>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default TermsModal;
